import {  ChangeDetectorRef, Component, CUSTOM_ELEMENTS_SCHEMA, ViewEncapsulation, OnDestroy, HostListener, ElementRef, OnInit, Output, EventEmitter } from '@angular/core';
import { ShareModule } from '../share.module';
import { ConditionGroup, FilterGroup, QueryCondition } from '../../models/filter-group.model';
import { SearchService } from '../services/search.service';
import { FilterCondition,QueryFilter } from '../../models/filter-condition.model';
import { SharedService } from '../services/shared.service';
import { Subject, Subscription, forkJoin, of } from 'rxjs';
import { debounceTime, map, switchMap, catchError, takeUntil } from 'rxjs/operators';
import { FilterPayload, GetFilterQueryResponse } from '../../models/filter-payload.model';
import { PagelayoutComponent } from '../pagelayout/pagelayout.component';
import { FormControl } from '@angular/forms';
import { Reference } from '../../models/reference';
import { CommonModule } from '@angular/common';
import { FilterCriteriaService } from '../services/filter-criteria.service';
import { DataService } from '../services/data.service';
import { Notification, NotificationComponent } from '../notification/notification.component';
import { ActivatedRoute, Router } from '@angular/router';
import { LandingPageApiService } from '../services/landing-page-api.service';
import { DATE_FIELDS, DEFAULT_GROUP, QUERY_TYPE, QueryType, SaveAsFilterType, SaveFilterType, USER_TYPE, VAS_TYPE_OPTIONS } from '../constants/constants';
import {
  ALL_FIELDS,
  BOOLEAN_FIELDS,
  FIELD_VALUE_OPTIONS,
  MULTI_SELECT_FIELDS,
  OPERATORS,
  SERVICE_PARTNER_TYPE_OPTIONS,
  VAS_LEVEL_OPTIONS,
} from '../constants/filter-criteria.constants';
import { FilterCriteriaDataService } from './services/filter-criteria-data.service';
import { FilterCriteriaGroupComponent } from './filter-criteria-group/filter-criteria-group.component';
import { sortQueriesByFavoriteAndName as sortQueriesByFavoriteAndNameUtil } from '../shared/utils/query-sorting.util';
import { readFirstExcelColumn } from '../shared/utils/excel-file.util';
@Component({
  selector: 'app-filter-criteria',
  standalone: true,
  imports: [ShareModule,PagelayoutComponent,CommonModule, NotificationComponent, FilterCriteriaGroupComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  templateUrl: './filter-criteria.component.html',
  styleUrl: './filter-criteria.component.scss',
  encapsulation: ViewEncapsulation.None

})
export class FilterCriteriaComponent implements OnInit, OnDestroy {

private static readonly DEFAULT_TEMPLATE_SEARCH_COLUMNS = ['id', 'name', 'type', 'comments'];

/**
 * Emits whenever a template/query's favourite state is toggled from the
 * Load Template/Query modal, so the host component can refresh any
 * favourites list it shows elsewhere (e.g. the side-pane accordions) without
 * waiting for them to be re-expanded or the page to be refreshed.
 */
@Output() favoriteChanged = new EventEmitter<void>();

private ivkSearchSubscription?: Subscription;
readonly supportUserRole = USER_TYPE.SUPPORT_USER;
showVersionHistoryModal: boolean = false;
versionHistory: any[] = [];
filteredVersionHistory: any[] = [];
selectedVersions: any[] = [];
versionSearchText: string = '';
descriptionSearchText: string = '';
showDeleteVersionModal: boolean = false;
versionToDelete: any = null;
isDeletingVersion: boolean = false;
filterCriteriaSearchText: string = '';
resultsSearchText: string = '';
editingVersionComment: any = null;
versionCommentText: string = '';
isSavingVersionComment: boolean = false;
countryApproval: boolean = false;
selectedQuery: any;
inputfield: any;
notes:string='';
countries: Reference[] = [];
showRangeDialog: boolean = false;
currentRangeCondition: QueryCondition | null = null;
rangeSearchText: string = '';
filteredRanges: string[] = [];
includedValues: string = '';
excludedValues: string = '';
deleteConfirmationMessage: string = '';
showDeleteMessage: boolean = false;
isModalVisible: boolean = false;
showDeliveryDate: boolean = false;
deliveryDate: string = '';
filterName: string = '';
currentFilterGuid: string = '';
currentFilterType: 'filter' | 'template' = 'filter';
comments: string = '';
summaryTitle: string = 'Summary';
selectedTemplate: string = '';
updatedVersion:string = '';
globalQueryValue = '';
showUnsavedChangesModal: boolean = false;
pendingVersionToLoad: any = null;
isDefaultQuery: boolean = false;
pendingNavigation: string | null = null;
// Template modal
showTemplateModal: boolean = false;
templateList: any[] = [];
filteredTemplateList: any[] = [];
selectedTemplateItem: any = null;
templateIdSearchText: string = '';
templateNameSearchText: string = '';
templateTypeSearchText: string = '';
templateCommentsSearchText: string = '';
templateGlobalSearchText: string = '';
templateSearchColumnsValue: string = FilterCriteriaComponent.DEFAULT_TEMPLATE_SEARCH_COLUMNS.join(',');
templateSearchColumns = [
  { key: 'id', label: 'Template ID' },
  { key: 'name', label: 'Template Name' },
  { key: 'type', label: 'Type' },
  { key: 'comments', label: 'Comments' }
];
// Reorderable / sortable column definitions for the Version History table
versionColumns: { field: string; header: string; filter: 'text' | 'none'; headerTooltip: string; searchTooltip?: string }[] = [
  { field: 'versionNo', header: 'Version', filter: 'text', headerTooltip: 'filter-criteria.tooltip.vhVersion', searchTooltip: 'filter-criteria.tooltip.vhVersionSearch' },
  { field: 'description', header: 'Description', filter: 'text', headerTooltip: 'filter-criteria.tooltip.vhDescription', searchTooltip: 'filter-criteria.tooltip.vhDescriptionSearch' },
  { field: 'filterCriteria', header: 'Filter Criteria', filter: 'text', headerTooltip: 'filter-criteria.tooltip.vhFilterCriteria', searchTooltip: 'filter-criteria.tooltip.vhFilterCriteriaSearch' },
];
// Reorderable / sortable column definitions for the Use Template table
templateColumns: { field: string; header: string; filter: 'text' | 'select' | 'none'; headerTooltip: string; searchTooltip: string; isSortable: boolean }[] = [
  { field: 'favourite', header: 'Favourite', filter: 'none', headerTooltip: '', searchTooltip: '', isSortable: false },
  { field: 'id', header: 'Id', filter: 'text', headerTooltip: 'filter-criteria.tooltip.tmplId', searchTooltip: 'filter-criteria.tooltip.tmplSearchId', isSortable: true },
  { field: 'name', header: 'Template Name', filter: 'text', headerTooltip: 'filter-criteria.tooltip.tmplName', searchTooltip: 'filter-criteria.tooltip.tmplSearchName', isSortable: true },
  { field: 'type', header: 'Type', filter: 'select', headerTooltip: 'filter-criteria.tooltip.tmplType', searchTooltip: 'filter-criteria.tooltip.tmplSearchType', isSortable: true },
  { field: 'comments', header: 'Comments', filter: 'text', headerTooltip: 'filter-criteria.tooltip.tmplComments', searchTooltip: 'filter-criteria.tooltip.tmplSearchComments', isSortable: true },
];
templateTableColumns = [
  { key: 'favourite', label: 'Favourite', visible: true },
  { key: 'id', label: 'Id', visible: true },
  { key: 'name', label: 'Template Name', visible: true },
  { key: 'type', label: 'Type', visible: true },
  { key: 'comments', label: 'Comments', visible: true }
];
showTemplateColumnVisibilityPopup: boolean = false;
myTemplateList: any[] = [];
isTemplateOthersSearchLoading: boolean = false;
isShowingTemplateOthersResults: boolean = false;
myQueryList: any[] = [];
isQueryOthersSearchLoading: boolean = false;
isShowingQueryOthersResults: boolean = false;
versionCommentError: string = '';
isLoadingTemplates: boolean = false;
isNewFilterSaved: boolean = false;
notification: Notification = {
  description: '',
  label: '',
  type: '',
};
private originalState: {
  notes: string;
  groups: string; 
} = {
  notes: '',
  groups: ''
};
  
  private ivkCache = new Map<string, { id: string; name: string }[]>();
  readonly IVK_INLINE_LIMIT = 1;
  // LLM query
  selectedTab: string = QUERY_TYPE.MANUAL_QUERY;
  llmQueryText: string = '';
  generatedSQLQuery: string = '';
  llmManualQuery: string = ''; 
  isSaveAsModalVisible: boolean = false;
  isSaveWithValues: boolean = false;
  whichFilterType: SaveAsFilterType = 'Standard';
  savedFilterType: SaveFilterType = 'Standard';
  isSaving: boolean = false;
  readonly MAX_DESCRIPTION_LENGTH = 200;
  descriptionError: string = '';

  //For Comparing two objects
  originalGroups: ConditionGroup[] = [];
  openClearConfirmModal: boolean = false;
  expandManualQuery: boolean = false
  ciStatusActive: boolean = false;
  inputProjectId: string = '';
  initialVersion = '001';
  destroy$ = new Subject<void>();
  isFilterCriteriaLoaded: boolean = false;
  setAsFavoriteFilter: boolean = false;
  allQueries: any[] = [];
  filteredQueries: any[] = [];
  queryGlobalSearchText: string = '';
  showQueryColumnVisibilityPopup: boolean = false;
  queryColumns: { field: string; header: string; filter: 'text' | 'none'; headerTooltip: string; searchTooltip: string; isSortable: boolean }[] = [
    { field: 'favourite', header: 'Favourite', filter: 'none', headerTooltip: '', searchTooltip: '', isSortable: false },
    { field: 'id', header: 'Id', filter: 'text', headerTooltip: 'filter-criteria.tooltip.tmplId', searchTooltip: 'filter-criteria.tooltip.tmplSearchId', isSortable: true },
    { field: 'name', header: 'Name', filter: 'text', headerTooltip: 'filter-criteria.tooltip.tmplName', searchTooltip: 'filter-criteria.tooltip.tmplSearchName', isSortable: true },
    { field: 'comments', header: 'Comments', filter: 'text', headerTooltip: 'filter-criteria.tooltip.tmplComments', searchTooltip: 'filter-criteria.tooltip.tmplSearchComments', isSortable: true },
  ];
  queryTableColumns = [
    { key: 'favourite', label: 'Favourite', visible: true },
    { key: 'id', label: 'Id', visible: true },
    { key: 'name', label: 'Name', visible: true },
    { key: 'comments', label: 'Comments', visible: true }
  ];
  activeTab: 'template' | 'query' = 'template';
    constructor(
        private http: SearchService, 
        private sharedService: SharedService, 
        private cdr: ChangeDetectorRef, 
        public filterCriteriaDataService: FilterCriteriaDataService,
        private filterCriteriaService: FilterCriteriaService,
        public dataService: DataService,
        readonly activatedRoute: ActivatedRoute,
        readonly router: Router,
        private landingPageService: LandingPageApiService,
        private elementRef: ElementRef
    ) { }



  ngOnInit() {
    // Initialize SharedService with current form data
    this.updateSharedService();
    this.fetchGUIDFromActivateRoute();

    this.filterCriteriaDataService.partnerSearch$
  .pipe(
    debounceTime(300),
    switchMap(({ text, condition }) =>
      this.searchServicePartnersByTokens(text, condition.id)
    ),
    takeUntil(this.destroy$)
  )
  .subscribe(({ results, id }) => {
    this.filterCriteriaDataService.filteredPartnerMap[id] = results;
  });
 this.loadSavedFilterCriteria();

 this.sharedService.registerAutoSave((skipSave = false) => this.autoSaveIfChanged());
 this.sharedService.registerHasChanges(() => this.hasChanges());
 
 // Initialize scroll area height based on initial groups
 this.filterCriteriaDataService.updateScrollAreaHeight();

 // Register beforeunload event
 window.addEventListener('beforeunload', this.onBeforeUnload);
  this.sharedService.pendingNavigation$
    .pipe(takeUntil(this.destroy$))
    .subscribe((url) => {
      if (url) {
        this.pendingNavigation = url;
        this.pendingVersionToLoad = null;
        this.showUnsavedChangesModal = true;
        this.sharedService.clearPendingNavigation();
      }
  });

   this.ivkSearchSubscription = this.filterCriteriaDataService.ivkSearch$.pipe(
                debounceTime(600),
          switchMap(({ condId, matNos }) => {
            this.filterCriteriaDataService.ivkLoadingMap[condId] = true;
            const cacheKey = matNos.join(',');
            const cached = this.ivkCache.get(cacheKey);

            // Same mat numbers requested again → return last result instantly
            if (cached) {
              return of({ condId, results: cached });
            }

            return this.filterCriteriaService.getIVKDescription(matNos).pipe(
              catchError(() => of([])),
              map(results => {
                this.ivkCache.set(cacheKey, results);
                return { condId, results };
              })
            );
      })
    ).subscribe(({ condId, results }) => {
      this.filterCriteriaDataService.ivkMap[condId] = results;
      this.filterCriteriaDataService.ivkLoadingMap[condId] = false;
      this.cdr.detectChanges();
    });
  }

  private searchServicePartnersByTokens(text: string, conditionId: number) {
    const searchTokens = this.getServicePartnerSearchTokens(text);

    if (!searchTokens.length) {
      return of({ results: [], id: conditionId });
    }

    const requests = searchTokens.map((token) =>
      this.http.getServicePartnerSuggestions(token).pipe(
        catchError(() => of([])),
      ),
    );

    return forkJoin(requests).pipe(
      map((resultsByToken) => {
        const merged = resultsByToken.flat();
        const deduped = merged.filter(
          (partner, index, arr) =>
            arr.findIndex((item) => item.id === partner.id) === index,
        );

        return { results: deduped, id: conditionId };
      }),
    );
  }

  private getServicePartnerSearchTokens(text: string): string[] {
    const normalizedText = String(text ?? '').trim();
    if (!normalizedText) {
      return [];
    }

    return normalizedText
      .split(',')
      .map((token) => token.trim())
      .filter(Boolean);
  }

  fetchGUIDFromActivateRoute() {
    this.dataService.selectedGUID = this.activatedRoute.snapshot.paramMap.get('id') ?? '';
  }

  ngOnDestroy(): void {
    this.sharedService.unregisterAutoSave();
    this.sharedService.unregisterHasChanges();
    this.destroy$.next();
    this.destroy$.complete();
    this.filterCriteriaDataService.groups = [];
    
    this.autoSaveIfChanged().then((success) => {
      if (success) {
      } else {
      }
    });

    this.notification = {} as Notification;

    // Remove beforeunload listener
    window.removeEventListener('beforeunload', this.onBeforeUnload);
     this.ivkSearchSubscription?.unsubscribe();
  }


  addNewGroup(groupLogic: 'AND' | 'OR' = 'AND') {
    
    const newGroup: ConditionGroup = {
      logic: groupLogic,
      conditions: [
        {
          id: this.filterCriteriaDataService.generateConditionId(),
          field: '',
          operator: OPERATORS.EQUAL,
          value: '',
          servicePartnerControl: new FormControl(''),
          depth: 0
        }
      ],
      collapsed: false,
      isExpanded: true,
      name: `Group ${this.filterCriteriaDataService.groups.length + 1} Notes`,
      id: this.filterCriteriaDataService.generateGroupId()
    };

    if (groupLogic === 'AND') {
      let insertAt = 0;

      for (let i = 0; i < this.filterCriteriaDataService.groups.length; i++) {
        if (this.filterCriteriaDataService.groups[i].logic === 'AND') {
          insertAt = i + 1;
        } else {
          break; 
        }
      }

      this.filterCriteriaDataService.groups.splice(insertAt, 0, newGroup);
      this.filterCriteriaDataService.scrollToConditionRow(insertAt, 0, this.elementRef);
    } else {
      this.filterCriteriaDataService.groups.push(newGroup);
      this.filterCriteriaDataService.scrollToConditionRow(this.filterCriteriaDataService.groups.length - 1, 0, this.elementRef);
    }
    
    this.filterCriteriaDataService.updateScrollAreaHeight();
  }

private getCanonicalDisplayValue(field: 'eqstatus' | 'eqsubstatus', rawValue: string): string {
  const valueMap = field === 'eqstatus'
    ? this.filterCriteriaDataService.deduplicateOptions(this.filterCriteriaDataService.eqStatusRawOptions).valueMap
    : this.filterCriteriaDataService.deduplicateOptions(this.filterCriteriaDataService.eqSubstatusRawOptions).valueMap;
  for (const [canonical, raws] of Object.entries(valueMap)) {
    if (raws.some(r => r.toLowerCase() === rawValue.toLowerCase())) {
      return canonical;
    }
  }
  return rawValue;
}

displayPartner(id: string, condId: number): string {
  const match = this.filterCriteriaDataService.filteredPartnerMap[condId]?.find(opt => opt.id === id);
  return match ? match.name : id;
}

  onFileUploadTrigger(condition: QueryCondition): void {
    // This will trigger the hidden file input click
    const fileInput = document.querySelector(`input[type="file"]#fileInput${condition.id}`) as HTMLInputElement;
    if (fileInput) {
      fileInput.click();
    }
  }


private labelToValue: Record<string, string> =
  ALL_FIELDS.reduce((acc, f) => ({ ...acc, [f.label]: f.value }), {});
private valueToValue: Record<string, string> =
  ALL_FIELDS.reduce((acc, f) => ({ ...acc, [f.value]: f.value }), {});

private toApiField(field: string): string {
  return this.labelToValue[field] ?? this.valueToValue[field] ?? field;
}

private getNormalizationOptions(field: string): string[] {
  const f = field?.toLowerCase();
  if (f === 'eq status') { return this.filterCriteriaDataService.eqStatusOptions; }
  if (f === 'eq substatus') { return this.filterCriteriaDataService.eqSubstatusOptions; }
  return FIELD_VALUE_OPTIONS[f] || [];
}

private normalizeToRawOption(field: string, value: any): any {
  if (value == null) { return value; }

  const options = this.getNormalizationOptions(field);
  if (!options.length) { return value; }

  const mapOne = (raw: string): string => {
    const v = String(raw).trim();
    if (!v) { return v; }
    const match = options.find(opt => opt.toLowerCase() === v.toLowerCase());
    return match ?? v;
  };

  if (Array.isArray(value)) {
    return value.map(v => mapOne(String(v)));
  }
  if (typeof value === 'string' && value.includes(',')) {
    return value.split(',').map(v => mapOne(v)).join(',');
  }
  return mapOne(String(value));
}

 convertValueForBackend(field: string, value: any): string {
  const fieldLower = field.toLowerCase();

  if (this.isDaSwDescriptionField(fieldLower)) {
    return JSON.stringify(this.resolveDaSwDescriptionSelections(fieldLower, value));
  }

  value = this.normalizeToRawOption(field, value);
  const stringValue = String(value);

    const specialValue = this.tryConvertSpecialField(fieldLower, value);
    if (specialValue !== undefined) {
      return specialValue;
  }

  if (this.isDateField(fieldLower)) {
    return this.extractDate(stringValue);
  }

  if (fieldLower === 'refurbished') {
    return this.mapYesNo(stringValue);
  }

  if (this.isBooleanField(fieldLower)) {
    return this.mapBoolean(stringValue);
  }

  if (this.isDaSwFlagField(fieldLower)) {
    return this.handleDaSwFlagForBackend(value, stringValue);
  }

  if (fieldLower === 'refurbished / reconditioned' && Array.isArray(value)) {
    // When user selects 'N', match both 'N' and 'n' in backend
    return value.flatMap((v: string) => v === 'N' ? ['N', 'n'] : [v]).join(',');
  }

  if (this.isMultiselectField(fieldLower) && Array.isArray(value)) {
    return value.join(',');
  }

  return stringValue;
}

private tryConvertSpecialField(field: string, value: any): string | undefined {
  if (field === 'service partner type') {
    return this.handleServicePartnerType(value);
  }
  if (field === 'update handling priority') {
    return this.handleUpdateHandlingPriority(value);
  }
  if (this.isBusinessLine(field, value) || this.isVasType(field, value) || this.isVasLevel(field, value)) {
    return value.join(',');
  }
  if (this.isCiField(field)) {
    return this.handleCiField(field, value);
  }
  if (field === 'country') {
    return this.handleCountry(value);
  }
  return undefined;
}

private isBusinessLine(field: string, value: any): boolean {
  return field === 'business line' && Array.isArray(value);
}

private handleServicePartnerType(value: any): string {
  const toCode = (v: string): string => {
    const raw = String(v).trim();
    if (!raw) { return ''; }
    // Handle "P - Business Partner" -> "P"
    const prefix = raw.split(' - ')[0].trim();
    const match = SERVICE_PARTNER_TYPE_OPTIONS.find(
      o =>
        o.id.toLowerCase() === prefix.toLowerCase() ||
        `${o.id} - ${o.name}`.toLowerCase() === raw.toLowerCase() ||
        o.name.toLowerCase() === raw.toLowerCase()
    );
    return match ? match.id : prefix;
  };

  const values = Array.isArray(value)
    ? value
    : String(value).split(',').map(v => v.trim()).filter(Boolean);

  return values.map(toCode).filter(Boolean).join(',');
}

private handleUpdateHandlingPriority(value: any): string {
  const toCode = (item: string): string => {
    const raw = String(item).trim();
    if (!raw) { return ''; }
    return raw.split(' - ')[0].trim().toLowerCase();
  };

  const values = Array.isArray(value) ? value : String(value).split(',');
  return values.map(toCode).filter(Boolean).join(',');
}

private handleDaSwFlagForBackend(value: any, stringValue: string): string {
  if (Array.isArray(value)) {
    return value.map((v: string) => this.mapDaSwFlagForBackend(v)).join(',');
  }
  return this.mapDaSwFlagForBackend(stringValue);
}

private isVasType(field: string, value: any): boolean {
  return field === 'vas type' && Array.isArray(value);
}

private isVasLevel(field: string, value: any): boolean {
  return field === 'vas level' && Array.isArray(value);
}

private isCiField(field: string): boolean {
  return field === 'eq status' || field === 'eq substatus';
}

private handleCiField(field: string, value: any): string {
  const options = field === 'eq status'
    ? this.filterCriteriaDataService.eqStatusRawOptions
    : this.filterCriteriaDataService.eqSubstatusRawOptions;

  const { valueMap } = this.filterCriteriaDataService.deduplicateOptions(options);
  const selections = Array.isArray(value) ? value : [String(value)];

  return selections
    .flatMap(v => valueMap[v] || [v])
    .join(',');
}

private handleCountry(value: any): string {
  let values: string[];
  if (Array.isArray(value)) {
    values = value;
  } else {
    const stringValue = String(value);
    if (stringValue.includes(',')) {
      values = stringValue.split(',').map(v => v.trim());
    } else {
      values = [stringValue];
    }
  }

  return values
    .map(v => {
      const trimmedValue = v.trimEnd();
      if (!trimmedValue.endsWith(')')) {
        return v;
      }

      const closingIndex = trimmedValue.length - 1;
      const previousClosingIndex = trimmedValue.lastIndexOf(')', closingIndex - 1);
      const openingIndex = trimmedValue.indexOf('(', previousClosingIndex + 1);
      return openingIndex !== -1 && openingIndex + 1 < closingIndex
        ? trimmedValue.slice(openingIndex + 1, closingIndex)
        : v;
    })
    .filter(Boolean)
    .join(',');
}

private isDateField(field: string): boolean {
  return DATE_FIELDS.includes(field);
}

private extractDate(value: string): string {
  return value.includes(' ') ? value.split(' ')[0] : value;
}

private mapYesNo(value: string): string {
  if (value === 'Yes') return 'Y';
  if (value === 'No') return 'N';
  return value;
}

private isBooleanField(field: string): boolean {
  return BOOLEAN_FIELDS.includes(field);
}

private mapBoolean(value: string): string {
  if (value === 'true') return 't';
  if (value === 'false') return 'f';
  return value;
}

private isDaSwFlagField(field: string): boolean {
  return field === 'da_sw upgrade' || field === 'da_sw update';
}

private isDaSwDescriptionField(field: string): boolean {
  return field === 'da_sw upgrade value' || field === 'da_sw update value';
}

/**
 * Resolve the discrete DA SW description selections into an array of full option strings.
 * The editable multi-select can emit the selections as a single comma-joined string (and even
 * as a one-element array wrapping that joined string), using the title-cased display label.
 * Because each predefined description itself contains commas, the join is ambiguous, so we
 * reconstruct the individual selections by greedily matching the known options case-insensitively.
 */
private resolveDaSwDescriptionSelections(fieldLower: string, value: any): string[] {
  const options = FIELD_VALUE_OPTIONS[fieldLower] || [];
  const pieces = Array.isArray(value) ? value.map(v => String(v)) : [String(value ?? '')];

  const selections: string[] = [];
  for (const piece of pieces) {
    const trimmed = piece.trim();
    if (trimmed === '') {
      continue;
    }
    selections.push(...this.splitDaSwDescriptionString(trimmed, options));
  }

  return selections;
}

private splitDaSwDescriptionString(raw: string, options: string[]): string[] {
  // Match longest options first so a description that is a prefix of another cannot be
  // matched prematurely. Matching is case-insensitive because the editable dropdown emits
  // the title-cased display label rather than the raw option value.
  const sortedOptions = [...options].sort((a, b) => b.length - a.length);
  const selections: string[] = [];
  let rest = raw;

  while (rest.length > 0) {
    const restLower = rest.toLowerCase();
    const matched = sortedOptions.find(option => {
      const optionLower = option.toLowerCase();
      return restLower === optionLower || restLower.startsWith(`${optionLower},`);
    });
    if (!matched) {
      // Unknown / free-text value: keep the remaining text as one literal.
      selections.push(rest);
      break;
    }
    // Push the canonical option; slicing by its length is safe because casing preserves length.
    selections.push(matched);
    rest = rest.slice(matched.length).replace(/^,\s*/, '');
  }

  return selections;
}

private isMultiselectField(field: string): boolean {
  return MULTI_SELECT_FIELDS.includes(field);
}

private mapDaSwFlagForBackend(value: string): string {
  const normalizedValue = value.trim();
  if (normalizedValue === 't' || normalizedValue === 'T') return 'X';
  if (normalizedValue === 'f' || normalizedValue === 'F') return '';
  return value;
}

private isValueEmpty(value: any): boolean {
  if (value === undefined || value === null || value === '') {
    return true;
  }
  
  if (Array.isArray(value)) {
    return value.length === 0 || value.every(item => !item || item === '');
  }
  
  return false;
}

private mapRefurbishedFromBackend(value: string): string {
  if (value === 'Y') return 'Yes';
  if (value === 'N') return 'No';
  return value;
}

private mapBooleanFromBackend(value: string): string {
  if (value === 't') return 'true';
  if (value === 'f') return 'false';
  return value;
}

private mapDaSwFlagFromBackend(value: string): string {
  if (value === 'X' || value === 'x') return 'T';
  if (!value || value.trim() === '') return 'F';
  return value;
}

private convertValueFromBackend(field: string, value: string): string | string[] {
  const fieldLower = field.toLowerCase();

  if (this.isDaSwDescriptionField(fieldLower)) {
    try {
      const parsedValue = JSON.parse(value);
      if (Array.isArray(parsedValue) && parsedValue.every(item => typeof item === 'string')) {
        return parsedValue;
      }
    } catch {
      return value;
    }
  }

  if (this.isDateField(fieldLower)) return this.extractDate(value);
  if (fieldLower === 'refurbished') return this.mapRefurbishedFromBackend(value);
  if (this.isBooleanField(fieldLower)) return this.mapBooleanFromBackend(value);
  if (this.isDaSwFlagField(fieldLower)) return this.mapDaSwFlagFromBackend(value);
  
  return value;
}





preparePayload(): FilterPayload {
  // Notes are keyed by groupId, so every group must carry one into the saved JSON.
  this.filterCriteriaDataService.ensureGroupIds();
  const groupPayloads: { group: FilterGroup, connectLogic: 'AND' | 'OR' }[] = [];

  for (const uiGroup of this.filterCriteriaDataService.groups) {
    const groupConditions = this.buildGroupConditions(uiGroup);
    
    if (groupConditions.length === 0) {
      continue;
    }

    const internalOperator = this.determineGroupInternalOperator(groupConditions);
    
    const filterGroup: FilterGroup = {
      type: 'Group',
      operator: internalOperator,
      conditions: groupConditions,
      name: uiGroup.name || null,
      groupId: uiGroup.id || null
    };

    // For first group, connectLogic doesn't matter (nothing to connect to)
    // For subsequent groups, use the group's logic property to determine how it connects
    const connectLogic = uiGroup.logic || 'AND';
    groupPayloads.push({ group: filterGroup, connectLogic });
  }

  if (groupPayloads.length === 0) {
    return {
      rootGroup: {
        type: 'Group',
        operator: 'AND',
        conditions: [],
        name: null
      }
    };
  }

  if (groupPayloads.length === 1) {
    const singleGroup = groupPayloads[0].group;
    // If the group has a single condition that is itself a Group, return it directly
    // but preserve the outer group's name
    if (singleGroup.conditions.length === 1 && singleGroup.conditions[0].type === 'Group') {
      const innerGroup = singleGroup.conditions[0] as FilterGroup;
      // Preserve the outer group's name if the inner group doesn't have one
      return { 
        rootGroup: {
          ...innerGroup,
          name: singleGroup.name || innerGroup.name,
          groupId: singleGroup.groupId
        }
      };
    }
    return { rootGroup: singleGroup };
  }

  // Determine the root operator based on how groups are connected
  // If all groups connect with AND, use AND; if any uses OR, we need to structure differently
  const allAnd = groupPayloads.slice(1).every(g => g.connectLogic === 'AND');
  const allOr = groupPayloads.slice(1).every(g => g.connectLogic === 'OR');

  if (allAnd) {
    // All groups connected with AND
    return {
      rootGroup: {
        type: 'Group',
        operator: 'AND',
        conditions: groupPayloads.map(g => g.group),
        name: null
      }
    };
  } else if (allOr) {
    // All groups connected with OR
    return {
      rootGroup: {
        type: 'Group',
        operator: 'OR',
        conditions: groupPayloads.map(g => g.group),
        name: null
      }
    };
  } else {
    // Mixed logic - build nested structure to preserve order of operations
    // Process left to right, respecting operator precedence (AND before OR in grouping)
    return this.buildMixedLogicPayload(groupPayloads);
  }
}

private buildMixedLogicPayload(groupPayloads: { group: FilterGroup, connectLogic: 'AND' | 'OR' }[]): FilterPayload {
  // Build the structure left to right
  // Group 1 Notes AND Group 2 OR Group 3 => (Group 1 Notes AND Group 2) OR Group 3
  
  let result: FilterGroup = groupPayloads[0].group;
  
  for (let i = 1; i < groupPayloads.length; i++) {
    const { group, connectLogic } = groupPayloads[i];
    result = {
      type: 'Group',
      operator: connectLogic,
      conditions: [result, group],
      name: null
    };
  }
  
  return { rootGroup: result };
}

private buildGroupConditions(uiGroup: ConditionGroup): (FilterCondition | FilterGroup)[] {
  const result: (FilterCondition | FilterGroup)[] = [];
  let i = 0;

  while (i < uiGroup.conditions.length) {
    const condition = uiGroup.conditions[i];
    const depth = condition.depth || 0;

    if (depth > 0) {
      i++;
      continue;
    }

    const { finalCondition, nextIndex } = this.processParent(uiGroup, i);
    result.push(finalCondition);
    i = nextIndex;
  }

  return result;
}

private processParent(
  uiGroup: ConditionGroup,
  startIndex: number
): { finalCondition: FilterCondition | FilterGroup; nextIndex: number } {

  const parentCondition = uiGroup.conditions[startIndex];
  const parentFilter = this.createFilterCondition(parentCondition);

  const { children, nextIndex } = this.collectChildren(uiGroup, startIndex + 1);

  const finalCondition = this.buildParentWithChildren(parentFilter, children);

  return { finalCondition, nextIndex };
}

private collectChildren(
  uiGroup: ConditionGroup,
  startIndex: number
): {
  children: { filter: FilterCondition | FilterGroup; logic: 'AND' | 'OR' }[];
  nextIndex: number;
} {

  const children: { filter: FilterCondition | FilterGroup; logic: 'AND' | 'OR' }[] = [];
  let index = startIndex;

  while (index < uiGroup.conditions.length) {
    const condition = uiGroup.conditions[index];
    const depth = condition.depth || 0;

    if (depth === 0) break;

    if (depth === 1) {
      const { childResult, nextIndex } = this.processChild(uiGroup, index);
      children.push(childResult);
      index = nextIndex;
    } else {
      index++;
    }
  }

  return { children, nextIndex: index };
}

private processChild(
  uiGroup: ConditionGroup,
  startIndex: number
): {
  childResult: { filter: FilterCondition | FilterGroup; logic: 'AND' | 'OR' };
  nextIndex: number;
} {

  const condition = uiGroup.conditions[startIndex];
  const childFilter = this.createFilterCondition(condition);
  const childLogic = condition.logic || 'OR';

  const { grandchildren, nextIndex } = this.collectGrandchildren(uiGroup, startIndex + 1);

  let childResult: FilterCondition | FilterGroup = childFilter;

  const scopedGrandchildren = this.splitLeadingAndRowsFromOrBlock(grandchildren);
  if (scopedGrandchildren) {
    childResult = this.buildScopedParent(childFilter, scopedGrandchildren);
  } else if (grandchildren.length > 0) {
    childResult = this.buildChainFromChildren([
      { filter: childFilter, logic: 'OR' },
      ...grandchildren
    ]);
  }

  return {
    childResult: { filter: childResult, logic: childLogic },
    nextIndex
  };
}

private collectGrandchildren(
  uiGroup: ConditionGroup,
  startIndex: number
): {
  grandchildren: { filter: FilterCondition; logic: 'AND' | 'OR' }[];
  nextIndex: number;
} {

  const grandchildren: { filter: FilterCondition; logic: 'AND' | 'OR' }[] = [];
  let index = startIndex;

  while (index < uiGroup.conditions.length) {
    const condition = uiGroup.conditions[index];
    const depth = condition.depth || 0;

    if (depth === 2) {
      grandchildren.push({
        filter: this.createFilterCondition(condition),
        logic: condition.logic || 'OR'
      });
      index++;
    } else if (depth > 1) {
      index++;
    } else {
      break;
    }
  }

  return { grandchildren, nextIndex: index };
}

private buildParentWithChildren(
  parentFilter: FilterCondition,
  children: { filter: FilterCondition | FilterGroup; logic: 'AND' | 'OR' }[]
): FilterCondition | FilterGroup {

  if (children.length === 0) {
    return parentFilter;
  }

  const firstChildLogic = children[0].logic;

  const scopedChildren = this.splitLeadingAndRowsFromOrBlock(children);
  if (scopedChildren) {
    return this.buildScopedParent(parentFilter, scopedChildren);
  }

  const childrenChain = this.buildChainFromChildren(children);

  return {
    type: 'Group',
    operator: firstChildLogic,
    conditions: [parentFilter, childrenChain],
    name: null
  };
}

private buildScopedParent(
  parentFilter: FilterCondition,
  scoped: {
    attributes: { filter: FilterCondition | FilterGroup; logic: 'AND' | 'OR' }[];
    orBlock: { filter: FilterCondition | FilterGroup; logic: 'AND' | 'OR' }[];
  }
): FilterGroup {
  return {
    type: 'Group',
    operator: 'AND',
    conditions: [
      parentFilter,
      this.buildChainFromChildren(scoped.attributes),
      this.buildChainFromChildren(scoped.orBlock)
    ],
    name: null
  };
}

// Leading AND rows constrain the parent, so they apply to the whole trailing OR block:
// [AND X, AND Y, AND P, OR Q, OR R] => parent AND X AND Y AND (P OR Q OR R).
private splitLeadingAndRowsFromOrBlock(
  rows: { filter: FilterCondition | FilterGroup; logic: 'AND' | 'OR' }[]
): {
  attributes: { filter: FilterCondition | FilterGroup; logic: 'AND' | 'OR' }[];
  orBlock: { filter: FilterCondition | FilterGroup; logic: 'AND' | 'OR' }[];
} | null {
  const firstOrIndex = rows.findIndex((row, index) => index > 0 && row.logic === 'OR');
  if (firstOrIndex < 2) {
    return null;
  }

  const attributes = rows.slice(0, firstOrIndex - 1);
  const orBlock = rows.slice(firstOrIndex - 1);

  if (!attributes.every(row => row.logic === 'AND') || !orBlock.slice(1).every(row => row.logic === 'OR')) {
    return null;
  }

  return { attributes, orBlock };
}

/**
 * Build a chain of conditions from children array.
 * First element starts the chain, subsequent elements use their logic to connect.
 * Example: [OR A, AND B, OR C] => ((A AND B) OR C)
 */
private buildChainFromChildren(children: { filter: FilterCondition | FilterGroup, logic: 'AND' | 'OR' }[]): FilterCondition | FilterGroup {
  if (children.length === 0) {
    throw new Error('Cannot build chain from empty children array');
  }
  
  if (children.length === 1) {
    return children[0].filter;
  }
  
  // Start with the first child
  let result: FilterCondition | FilterGroup = children[0].filter;
  
  // Chain subsequent children using their logic operator
  for (let i = 1; i < children.length; i++) {
    const { filter, logic } = children[i];
    result = {
      type: 'Group',
      operator: logic,
      conditions: [result, filter],
      name: null
    };
  }
  
  return result;
}

private createFilterCondition(condition: QueryCondition): FilterCondition {
  const excludedValues = this.filterCriteriaDataService.excludedValuesMap[condition.id];
  const hasExcludedValues = excludedValues && excludedValues.trim() !== '';
  const hasIncludedValues = !this.isValueEmpty(condition.value);
  const value = hasExcludedValues && !hasIncludedValues
    ? excludedValues
    : condition.value;
  const selectedOperatorSymbol = this.filterCriteriaDataService.getOperatorSymbol(
    condition.operator,
  );
  const payloadOperator = selectedOperatorSymbol === '=,!='
    ? '='
    : selectedOperatorSymbol;

  const filter: FilterCondition = {
    type: 'Filter',
    field: this.toApiField(condition.field),
    operator: hasExcludedValues && !hasIncludedValues
      ? '!='
      : payloadOperator,
    value: this.convertValueForBackend(condition.field, value),
    name: null,
    depth: condition.depth || 0,
    logic: condition.logic || 'AND'
  };

  if (condition.valueTo && !this.isValueEmpty(condition.valueTo)) {
    filter.valueTo = this.convertValueForBackend(condition.field, condition.valueTo);
  }

  if (hasExcludedValues && hasIncludedValues) {
    filter.excludedValues = excludedValues;
  }

  return filter;
}

private determineGroupInternalOperator(conditions: (FilterCondition | FilterGroup)[]): 'AND' | 'OR' {
  if (conditions.length === 1) {
    const single = conditions[0];
    if (single.type === 'Group') {
      return single.operator;
    }
  }
  return 'AND';
}



isAnyConditionValueEmpty(): boolean {
  return this.filterCriteriaDataService.groups.some(group =>
    group.conditions.some(condition => this.isConditionInvalid(condition))
  );
}

hasAnyFilterValues(): boolean {
  return this.filterCriteriaDataService.groups.some((group) =>
    group.conditions.some((condition) => {
      const excludedValues = this.filterCriteriaDataService.excludedValuesMap[condition.id];
      return (
        !this.isValueEmpty(condition.value) ||
        !this.isValueEmpty(condition.valueTo) ||
        !!excludedValues?.trim()
      );
    })
  );
}

runPrimarySaveAction(): void {
  this.onRefreshSummary();

  if (this.hasAnyFilterValues()) {
    this.onRunAndSave();
    return;
  }

  this.onSave();
}

private isConditionInvalid(condition: QueryCondition): boolean {
  const excludedValues = this.filterCriteriaDataService.excludedValuesMap[condition.id];
  const hasExcludedValues = !!excludedValues?.trim();

  return (
    this.isMissingFieldOrOperator(condition) ||
    (this.isValueEmpty(condition.value) && !hasExcludedValues) ||
    this.hasCombinationError(condition) ||
    this.hasInvalidDateRange(condition)
  );
}

private isMissingFieldOrOperator(condition: QueryCondition): boolean {
  return condition.field === '' || condition.operator === '';
}

private hasCombinationError(condition: QueryCondition): boolean {
  const sym = this.filterCriteriaDataService.getOperatorSymbol(condition.operator);
  return sym === 'combination' && !!this.filterCriteriaDataService.combinationErrors[condition.id];
}

private hasInvalidDateRange(condition: QueryCondition): boolean {
  if (
    !this.isDateField(condition.field?.toLowerCase()) ||
    !this.filterCriteriaDataService.isDateRangeOperator(condition.operator) ||
    !condition.value ||
    !condition.valueTo
  ) {
    return false;
  }

  const startDate = new Date(condition.value);
  const endDate = new Date(condition.valueTo);
  return (
    !Number.isNaN(startDate.getTime()) &&
    !Number.isNaN(endDate.getTime()) &&
    startDate > endDate
  );
}

  resultData: any[] = [];

  testRun() {
    const payload = this.preparePayloadForTestRun();
    this.sharedService.triggerTestRun(payload, 'manual');
    setTimeout(() => {
      const anchor = document.getElementById('volume-table-anchor');
      if (anchor) {
        anchor.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
      // Scroll to the bottom of the page
      window.scrollTo({ 
        top: document.documentElement.scrollHeight, 
        behavior: 'smooth' 
      });
    }, 100);
  }

  querySummary: { text: string, nested: boolean }[] = [];

    private preparePayloadForTestRun(): FilterPayload {
  return this.preparePayload();
}

onRefreshSummary(): void {
  this.querySummary = [];

  if (this.selectedTab !== QUERY_TYPE.MANUAL_QUERY) {
    this.querySummary = [{ text: this.generatedSQLQuery, nested: false }];
    return;
  }

  const summary: { text: string; nested: boolean }[] = [];

  for (const group of this.filterCriteriaDataService.groups) {
    this.processGroup(group, summary);
  }

  this.querySummary = summary;
}

private processGroup(
  group: any,
  summary: { text: string; nested: boolean }[]
): void {
  for (let condIndex = 0; condIndex < group.conditions.length; condIndex++) {
    const condition = group.conditions[condIndex];

    if (!this.isValidCondition(condition)) continue;

    const { logicPrefix, nested } = this.getLogicDetails(condition, condIndex, group.logic);

    let displayValue = condition.value;

    // Append IVK name for Material No. (System)
    if (this.filterCriteriaDataService.isMaterialNoField(condition.field)) {
      const condId = condition.id.toString();
      const ivkEntries = this.filterCriteriaDataService.ivkMap[condId];
      if (ivkEntries && ivkEntries.length > 0) {
        displayValue = ivkEntries
          .map((ivk: { id: string; name: string }) => `${ivk.id} - ${ivk.name}`)
          .join(', ');
      }
    }

    // Show "code - name" for Service Partner Type
    if (condition.field === 'Service Partner Type') {
      displayValue = this.displayServicePartnerType(condition.value);
    }

    summary.push({
      text: `${logicPrefix}${condition.field} ${this.filterCriteriaDataService.getOperatorSymbol(condition.operator)} ${displayValue}${condition.valueTo ? 'to ' + condition.valueTo : ''}`,
      nested
    });
  }
}


private isValidCondition(condition: any): boolean {
  return condition.field && condition.operator && condition.value !== '';
}

private getLogicDetails(
  condition: any,
  condIndex: number,
  groupLogic: string
): { logicPrefix: string; nested: boolean } {

  if (condIndex === 0) {
    return { logicPrefix: groupLogic + ' ', nested: false };
  }

  if (condition.logic === 'OR') {
    return { logicPrefix: 'OR ', nested: true };
  }

  return { logicPrefix: 'AND ', nested: false };
}

showRangeField(field: string, operator: string): boolean {
  return false;
}

displayBusinessLine = (value: string | string[]): string => {
  if (!value) return '';
  
  if (Array.isArray(value)) {
    return value.join(', ');
  }
  
  if (typeof value === 'string') {
    if (value.includes(',')) {
      const names = value.split(',').map(n => n.trim()).filter(n => n);
      return names.join(', ');
    }
    
    return value;
  }
  
  return String(value);
};

displayServicePartnerType = (value: string | string[]): string => {
  if (!value) return '';

  const mapCode = (code: string): string => {
    const raw = String(code).trim();
    const option = SERVICE_PARTNER_TYPE_OPTIONS.find(o => o.id.toLowerCase() === raw.toLowerCase());
    return option ? `${option.id} - ${option.name}` : raw;
  };

  if (Array.isArray(value)) {
    return value.map(mapCode).filter(Boolean).join(', ');
  }

  if (typeof value === 'string') {
    if (value.includes(',')) {
      return value.split(',').map(v => mapCode(v.trim())).filter(Boolean).join(', ');
    }
    return mapCode(value);
  }

  return String(value);
};

displayVasType = (value: string | string[]): string => {
  if (!value) return '';

  const mapCode = (code: string): string => {
    const option = VAS_TYPE_OPTIONS.find(o => o.id === code);
    return option ? `${option.id} - ${option.name}` : code;
  };

  if (Array.isArray(value)) {
    return value.map(mapCode).join(', ');
  }

  if (typeof value === 'string') {
    if (value.includes(',')) {
      return value.split(',').map(v => mapCode(v.trim())).filter(v => v).join(', ');
    }
    return mapCode(value);
  }

  return String(value);
};

displayVasLevel = (value: string | string[]): string => {
  if (!value) return '';

  const mapCode = (code: string): string => {
    // Handle TYPE:LEVEL format (e.g., "AS:1")
    if (code.includes(':')) {
      const [vasType, level] = code.split(':');
      const option = VAS_LEVEL_OPTIONS.find(o => o.vasType === vasType && o.level === level);
      return option ? `${option.level} - ${option.name}` : code;
    }
    const option = VAS_LEVEL_OPTIONS.find(o => o.level === code);
    return option ? `${option.level} - ${option.name}` : code;
  };

  if (Array.isArray(value)) {
    return value.map(mapCode).join(', ');
  }

  if (typeof value === 'string') {
    if (value.includes(',')) {
      return value.split(',').map(v => mapCode(v.trim())).filter(v => v).join(', ');
    }
    return mapCode(value);
  }

  return String(value);
};

displayCountryMultiselect = (value: string | string[]): string => {
  if (!value) return '';
  
  if (Array.isArray(value)) {
    return value.join(', ');
  }
  
  if (typeof value === 'string') {
    if (value.includes(',')) {
      return value.split(',').map(v => v.trim()).join(', ');
    }
    return value;
  }
  
  return String(value);
};

displayContractType = (value: string | string[]): string => {
  if (!value) return '';
  
  if (Array.isArray(value)) {
    return value.join(', ');
  }
  
  if (typeof value === 'string') {
    if (value.includes(',')) {
      return value.split(',').map(v => v.trim()).join(', ');
    }
    return value;
  }
  
  return String(value);
};
getModalTitle(): string {
  if (this.currentRangeCondition?.field) {
    return `${this.currentRangeCondition.field} Values`;
  }
  return 'Field Values';
}

openSingleValueModal(condition: QueryCondition): void {
  this.currentRangeCondition = condition;
  this.showRangeDialog = true;
  this.rangeSearchText = '';
  const initialIncluded = condition.value ? String(condition.value) : '';
  const initialExcluded =
    this.filterCriteriaDataService.excludedValuesMap[condition.id] || '';

  this.excludedValues = this.normalizeSeparators(initialExcluded);
  this.includedValues = this.removeExcludedFromIncluded(
    this.normalizeSeparators(initialIncluded),
    this.excludedValues,
  );
  condition.value = this.includedValues;
  this.filterCriteriaDataService.excludedValuesMap[condition.id] =
    this.excludedValues;

  this.filterCriteriaDataService.rangeSearchText = this.rangeSearchText;
  this.filterCriteriaDataService.includedValues = this.includedValues;
  this.filterCriteriaDataService.excludedValues = this.excludedValues;
  this.filterCriteriaDataService.updateFilteredRanges();
  this.filteredRanges = this.filterCriteriaDataService.filteredRanges;
}

closeRangeDialog(): void {
  this.showRangeDialog = false;
  this.currentRangeCondition = null;
  this.rangeSearchText = '';
  this.includedValues = '';
  this.excludedValues = '';
  this.filteredRanges = [];
  this.filterCriteriaDataService.rangeSearchText = '';
  this.filterCriteriaDataService.includedValues = '';
  this.filterCriteriaDataService.excludedValues = '';
  this.filterCriteriaDataService.filteredRanges = [];
}

closeSingleValueModal(): void {
  this.closeRangeDialog();
  if (this.currentRangeCondition && this.filterCriteriaDataService.isMaterialNoField(this.currentRangeCondition.field)) {
      const condId = this.currentRangeCondition.id.toString();
      const hasValues = (this.includedValues?.trim() || '') !== '' || 
                        (this.excludedValues?.trim() || '') !== '';
      if (!hasValues) {
        this.filterCriteriaDataService.ivkMap[condId] = [];
        this.cdr.detectChanges();
      }
    }
}

getIncludedValuesCount(): number {
  return this.filterCriteriaDataService.getRangeValues().length;
}

getExcludedValuesCount(): number {
  return this.filterCriteriaDataService.getExcludedValues().length;
}

isValueInIncluded(value: string): boolean {
  const includedValues = this.filterCriteriaDataService.getRangeValues();
  return includedValues.includes(value);
}

isValueInExcluded(value: string): boolean {
  const excludedValues = this.filterCriteriaDataService.getExcludedValues();
  return excludedValues.includes(value);
}

onRangeSearch(): void {
  this.filterCriteriaDataService.updateFilteredRanges();
}

onRangeSearchChange(searchText: string): void {
  this.rangeSearchText = searchText;
  this.filterCriteriaDataService.rangeSearchText = searchText;
  this.filterCriteriaDataService.updateFilteredRanges();
  this.filteredRanges = this.filterCriteriaDataService.filteredRanges;
}

onRangeSearchClear(): void {
  this.rangeSearchText = '';
  this.filterCriteriaDataService.rangeSearchText = '';
  this.filterCriteriaDataService.updateFilteredRanges();
  this.filteredRanges = this.filterCriteriaDataService.filteredRanges;
}

deleteValue(valueToDelete: string): void {
  const includedValues = this.filterCriteriaDataService.getRangeValues();
  const excludedValues = this.filterCriteriaDataService.getExcludedValues();

  const isInIncluded = includedValues.includes(valueToDelete);
  const isInExcluded = excludedValues.includes(valueToDelete);

  const updatedIncluded = isInIncluded
    ? includedValues.filter(value => value !== valueToDelete)
    : includedValues;
  const updatedExcluded = isInExcluded
    ? excludedValues.filter(value => value !== valueToDelete)
    : excludedValues;

  this.includedValues = updatedIncluded.join(', ');
  this.excludedValues = updatedExcluded.join(', ');

  this.filterCriteriaDataService.includedValues = this.includedValues;
  this.filterCriteriaDataService.excludedValues = this.excludedValues;

  if (this.currentRangeCondition) {
    this.currentRangeCondition.value = this.includedValues;
    this.filterCriteriaDataService.excludedValuesMap[this.currentRangeCondition.id] = this.excludedValues;
  }

  this.filterCriteriaDataService.updateFilteredRanges();
  this.filteredRanges = this.filterCriteriaDataService.filteredRanges;

  this.showDeleteConfirmation(valueToDelete);
}

showDeleteConfirmation(deletedValue: string): void {
  this.deleteConfirmationMessage = `Value "${deletedValue}" removed`;
  this.showDeleteMessage = true;
  
  setTimeout(() => {
    this.showDeleteMessage = false;
    this.deleteConfirmationMessage = '';
  }, 3000);
}

onIncludedValuesChange(value: string): void {
  const normalized = this.normalizeSeparators(value);
  this.includedValues = this.removeExcludedFromIncluded(
    normalized,
    this.excludedValues,
  );
  this.filterCriteriaDataService.includedValues = this.includedValues;
  if (this.currentRangeCondition) {
    this.currentRangeCondition.value = this.includedValues;
  }
  this.filterCriteriaDataService.updateFilteredRanges();
  this.filteredRanges = this.filterCriteriaDataService.filteredRanges;
}

onExcludedValuesChange(value: string): void {
  const normalized = this.normalizeSeparators(value);
  this.excludedValues = normalized;
  this.includedValues = this.removeExcludedFromIncluded(
    this.includedValues,
    this.excludedValues,
  );
  this.filterCriteriaDataService.includedValues = this.includedValues;
  this.filterCriteriaDataService.excludedValues = normalized;
  if (this.currentRangeCondition) {
    this.currentRangeCondition.value = this.includedValues;
    this.filterCriteriaDataService.excludedValuesMap[this.currentRangeCondition.id] = normalized;
  }
  this.filterCriteriaDataService.updateFilteredRanges();
  this.filteredRanges = this.filterCriteriaDataService.filteredRanges;
}

normalizeSeparators(value: string): string {
  return this.filterCriteriaDataService.normalizeSeparators(value);
}

private splitModalValues(value: string): string[] {
  return (value || '')
    .split(',')
    .map((entry) => entry.trim())
    .filter(Boolean);
}

private removeExcludedFromIncluded(included: string, excluded: string): string {
  const excludedSet = new Set(this.splitModalValues(excluded));
  if (excludedSet.size === 0) {
    return included;
  }

  const filteredIncluded = this.splitModalValues(included).filter(
    (entry) => !excludedSet.has(entry),
  );
  return filteredIncluded.join(',');
}

addValuesToField(): void {
  this.updateCurrentRangeCondition();

  const conditionSnapshot = this.currentRangeCondition;
  const includedSnapshot = this.includedValues;
  const excludedSnapshot = this.excludedValues;
  this.closeRangeDialog();

  this.refreshMaterialNumberDescriptions(
    conditionSnapshot,
    includedSnapshot,
    excludedSnapshot,
  );
}

private updateCurrentRangeCondition(): void {
  if (!this.currentRangeCondition) {
    return;
  }

  this.currentRangeCondition.value = this.includedValues;
  this.filterCriteriaDataService.excludedValuesMap[this.currentRangeCondition.id] = this.excludedValues;

  const hasIncludedValues = this.includedValues.trim() !== '';
  const hasExcludedValues = this.excludedValues.trim() !== '';

  if (!hasIncludedValues && hasExcludedValues) {
    this.currentRangeCondition.operator =
      this.filterCriteriaDataService.getOperatorsLabel('!=');
    return;
  }

  if (hasIncludedValues) {
    this.currentRangeCondition.operator =
      this.filterCriteriaDataService.getOperatorsLabel(hasExcludedValues ? '=,!=' : '=');
    if (hasExcludedValues) {
      this.currentRangeCondition.value = this.includedValues + ',' + this.excludedValues;
    }
  }
}

private refreshMaterialNumberDescriptions(
  condition: QueryCondition | null,
  includedValue: string,
  excludedValue: string,
): void {
  if (!condition || !this.filterCriteriaDataService.isMaterialNoField(condition.field)) {
    return;
  }

  const matNos = this.getMaterialNumbers(includedValue, excludedValue);
  const condId = condition.id.toString();

  if (matNos.length > 0) {
    this.filterCriteriaDataService.ivkSearch$.next({ condId, matNos });
    return;
  }

  this.filterCriteriaDataService.ivkMap[condId] = [];
  this.filterCriteriaDataService.ivkLoadingMap[condId] = false;
  this.cdr.detectChanges();
}

private getMaterialNumbers(includedValue: string, excludedValue: string): string[] {
  const splitValues = (value: string): string[] =>
    value ? value.split(',').map(item => item.trim()).filter(Boolean) : [];

  return [...new Set([
    ...splitValues(includedValue),
    ...splitValues(excludedValue),
  ])];
}

onIncludedFileUpload(event: Event): void {
  const input = event.target as HTMLInputElement;
  const file = input.files?.[0];
  if (!file) return;

  const reader = new FileReader();
  reader.onload = async (e: ProgressEvent<FileReader>) => {
    const data = e.target?.result;
    if (!(data instanceof ArrayBuffer) && !ArrayBuffer.isView(data)) return;
    const flatValues = await readFirstExcelColumn(data);

    const existingValues = this.includedValues ? this.includedValues.split(',').map(v => v.trim()).filter(v => v) : [];
    const newValues = [...existingValues, ...flatValues];
    const uniqueValues = [...new Set(newValues)];
    
    this.includedValues = uniqueValues.join(', ');
    if (this.currentRangeCondition) {
      this.currentRangeCondition.value = this.includedValues;
    }
    this.filterCriteriaDataService.updateFilteredRanges();
  };

  reader.readAsArrayBuffer(file);
  input.value = '';
}

onExcludedFileUpload(event: Event): void {
  const input = event.target as HTMLInputElement;
  const file = input.files?.[0];
  if (!file) return;

  const reader = new FileReader();
  reader.onload = async (e: ProgressEvent<FileReader>) => {
    const data = e.target?.result;
    if (!(data instanceof ArrayBuffer) && !ArrayBuffer.isView(data)) return;
    const flatValues = await readFirstExcelColumn(data);

    const existingValues = this.excludedValues ? this.excludedValues.split(',').map(v => v.trim()).filter(v => v) : [];
    const newValues = [...existingValues, ...flatValues];
    const uniqueValues = [...new Set(newValues)];

    this.excludedValues = uniqueValues.join(', ');
    if (this.currentRangeCondition) {
      this.filterCriteriaDataService.excludedValuesMap[this.currentRangeCondition.id] = this.excludedValues;
    }
    this.filterCriteriaDataService.updateFilteredRanges();
  };

  reader.readAsArrayBuffer(file);
  input.value = '';
}


// Methods to sync data with SharedService
onNotesChange(notes: string): void {
  this.notes = notes;
  this.updateSharedService();
}

private loadSavedFilterCriteria(): void {
  const selectedGUID = this.dataService.selectedGUID;
  
  if (!selectedGUID) {
    if (this.dataService.queryCreationMode === 'empty') {
      this.loadEmptyFilter();
      this.dataService.queryCreationMode = 'default';
      return;
    }

    this.loadDefaultFilter();
    return;
  }

  this.dataService.queryCreationMode = 'default';

  this.filterCriteriaService.getFilterCriteria(selectedGUID).subscribe({
    next: (savedData) => {
      if (savedData) {
        this.isFilterCriteriaLoaded = true;
        // Store the current filter GUID for updates
        this.currentFilterGuid = selectedGUID;
        this.dataService.selectedQuery = savedData;
        this.updatedVersion = this.dataService.selectedQuery.versionNo;
        this.currentFilterType =
          savedData.filterType.toLocaleLowerCase() == 'standard' ||
          savedData.filterType.toLocaleLowerCase() == 'project'
            ? 'filter'
            : 'template';

        this.notes = '';
        this.handlePopulatingGroups(savedData.filter);
        this.originalGroups = JSON.parse(JSON.stringify(this.filterCriteriaDataService.groups));
        // Update SharedService with loaded data
        this.updateSharedService();
        
        // Capture the loaded state as original state for change tracking
        setTimeout(() => {
          this.triggerIVKForExistingConditions();
          this.captureCurrentState();
        }, 200);
        
        // Trigger change detection
        this.cdr.detectChanges();
      } else {
        // No saved data, capture current initial state
        setTimeout(() => {
          this.captureCurrentState();
        }, 100);
      }
    },
    error: (error) => {
      console.error('Error loading saved filter criteria:', error);
    }
  });
}

private loadEmptyFilter(): void {
  this.isFilterCriteriaLoaded = true;
  this.currentFilterGuid = '';
  this.dataService.selectedQuery = null;
  this.updatedVersion = '';
  this.currentFilterType = 'filter';
  this.notes = '';
  this.ciStatusActive = false;
  this.resetGroups();
  this.originalGroups = JSON.parse(JSON.stringify(this.filterCriteriaDataService.groups));
  this.updateSharedService();

  setTimeout(() => {
    this.captureCurrentState();
  }, 100);

  this.cdr.detectChanges();
}

private loadDefaultFilter(): void {
  this.filterCriteriaService.getDefaultFilter().subscribe({
    next: (defaultFilter) => {
      this.captureCurrentState(); 
      this.isFilterCriteriaLoaded = true;
      if (defaultFilter) {
        this.handlePopulatingGroups(defaultFilter.filter);
        this.originalGroups = JSON.parse(JSON.stringify(this.filterCriteriaDataService.groups));
        this.updateSharedService();
      } else {
        this.filterCriteriaDataService.groups = [{ ...DEFAULT_GROUP, id: this.filterCriteriaDataService.generateGroupId() }];
      }

      this.ciStatusActive = this.checkGlobalQueryForCIStatus(defaultFilter?.globalFilter);

      setTimeout(() => {
       this.triggerIVKForExistingConditions();
        this.captureCurrentState();
      }, 200);

      this.cdr.detectChanges();
    },
    error: (error) => {
      this.ciStatusActive = false;
      // 204 No Content or any error - fall back to empty state
      if (error?.status !== 204) {
        console.error('Error loading default filter:', error);
      }
      setTimeout(() => {
         this.captureCurrentState();
      }, 100);
    }
  });
}

private reconstructFiltersFromRootGroup(rootGroup: any): void {
  this.filterCriteriaDataService.combinationErrors = {};
  this.filterCriteriaDataService.excludedValuesMap = {};
  this.filterCriteriaDataService.filteredPartnerMap = {};
  this.filterCriteriaDataService.partnerSearchTextMap = {};
  this.filterCriteriaDataService.ivkMap = {};
  this.filterCriteriaDataService.ivkLoadingMap = {};
  this.ivkCache.clear();

  // Reset current groups
  this.filterCriteriaDataService.groups = [];
  this.filterCriteriaDataService.resetConditionId(1);
  
  // Handle empty conditions array - show one empty row
  if (rootGroup.type === 'Group' && rootGroup.operator === 'AND' && 
      rootGroup.conditions && Array.isArray(rootGroup.conditions) && rootGroup.conditions.length === 0) {
    this.filterCriteriaDataService.groups = [
      {
        logic: 'AND',
        conditions: [
          {
            id: this.filterCriteriaDataService.generateConditionId(),
            field: '',
            operator: OPERATORS.EQUAL,
            value: '',
            servicePartnerControl: new FormControl(''),
            depth: 0
          }
        ],
        name: 'Group 1 Notes',
        id: rootGroup.groupId || undefined
      }
    ];
    this.filterCriteriaDataService.ensureGroupIds();
    this.filterCriteriaDataService.updateScrollAreaHeight();
    this.filterCriteriaDataService.syncNextConditionIdFromGroups();
    return;
  }
  
  // Check if the conditions have depth information (new format)
  const hasDepthInfo = this.checkForDepthInfo(rootGroup);
  
  if (hasDepthInfo) {
    // New format: reconstruct using depth information
    this.reconstructWithDepthInfo(rootGroup);
  } else {
    // Legacy format: use old reconstruction logic
    this.reconstructLegacyFormat(rootGroup);
  }

  // Ensure at least one group exists
  if (this.filterCriteriaDataService.groups.length === 0) {
    this.filterCriteriaDataService.groups = [
      {
        logic: 'AND',
        conditions: [
          {
            id: this.filterCriteriaDataService.generateConditionId(),
            field: '',
            operator: '',
            value: '',
            servicePartnerControl: new FormControl(''),
            depth: 0
          }
        ],
        name: 'Group 1 Notes'
      }
    ];
  }

  this.filterCriteriaDataService.ensureGroupIds();
  this.filterCriteriaDataService.updateScrollAreaHeight();
  this.filterCriteriaDataService.syncNextConditionIdFromGroups();
}

/**
 * Check if the saved data has depth information (new format)
 */
private checkForDepthInfo(group: any): boolean {
  if (!group) return false;
  
  if (group.type === 'Filter' && group.depth !== undefined) {
    return true;
  }
  
  if (group.type === 'Group' && group.conditions) {
    for (const condition of group.conditions) {
      if (this.checkForDepthInfo(condition)) {
        return true;
      }
    }
  }
  
  return false;
}

/**
 * Reconstruct UI using depth information from the saved data
 */
private reconstructWithDepthInfo(rootGroup: any): void {
  if (rootGroup.type === 'Filter') {
    this.addSingleFilterAsGroup(rootGroup, 'AND', 'Group 1 Notes');
    return;
  }
  
  if (rootGroup.type === 'Group') {
    this.processGroupWithDepth(rootGroup);
  }
}

private processGroupWithDepth(rootGroup: any): void {
  const conditions = rootGroup.conditions || [];
  const hasGroupChildren = this.hasPotentialGroupChildren(conditions);
  
  if (hasGroupChildren) {
    this.processChildrenAsUIGroups(conditions, rootGroup.operator);
  } else {
    this.extractGroupWithDepth(rootGroup, 'AND');
  }
}

private hasPotentialGroupChildren(conditions: any[]): boolean {
  const hasNamedGroups = conditions.some((c: any) => c.type === 'Group' && c.name);
  const hasGroupAsFirstChild = conditions.length > 0 && conditions[0].type === 'Group';
  return hasNamedGroups || hasGroupAsFirstChild;
}

private processChildrenAsUIGroups(conditions: any[], rootOperator: 'AND' | 'OR'): void {
  for (let i = 0; i < conditions.length; i++) {
    const condition = conditions[i];
    const groupLogic = this.getGroupLogic(i, rootOperator);
    this.processChildCondition(condition, groupLogic);
  }
}

private getGroupLogic(index: number, rootOperator: 'AND' | 'OR'): 'AND' | 'OR' {
  return index === 0 ? 'AND' : rootOperator;
}

private processChildCondition(condition: any, groupLogic: 'AND' | 'OR'): void {
  if (condition.type === 'Group') {
    this.extractGroupWithDepth(condition, groupLogic);
  } else if (condition.type === 'Filter') {
    this.addSingleFilterAsGroup(condition, groupLogic, this.getGroupName(condition));
  }
}

private getGroupName(condition: any): string {
  return condition.name || `Group ${this.filterCriteriaDataService.groups.length + 1} Notes`;
}

private addSingleFilterAsGroup(condition: any, logic: 'AND' | 'OR', name: string): void {
  const reconstructedCondition = this.reconstructQueryCondition(condition);
  this.filterCriteriaDataService.groups.push({
    logic,
    conditions: [reconstructedCondition],
    name,
    collapsed: false,
    isExpanded: true
  });
}

/**
 * Extract a UI group from the saved data, preserving depth hierarchy
 */
private extractGroupWithDepth(group: any, groupLogic: 'AND' | 'OR'): void {
  const nestedGroups = (group.conditions || []).filter((condition: any) => condition.type === 'Group');

  if (!group.name && nestedGroups.length > 0 && nestedGroups.length === group.conditions.length) {
    nestedGroups.forEach((nestedGroup: any, index: number) => {
      const nestedGroupLogic = index === 0 ? groupLogic : group.operator || groupLogic;
      this.extractGroupWithDepth(nestedGroup, nestedGroupLogic);
    });
    return;
  }

  const uiConditions: QueryCondition[] = [];
  
  // Recursively extract all filters maintaining their depth
  this.extractFiltersRecursively(group, uiConditions);
  
  // Sort by depth to maintain hierarchy, but preserve original order within same depth
  // Actually, we should not sort - the order should be preserved from the original save
  
  if (uiConditions.length > 0) {
    this.filterCriteriaDataService.groups.push({
      logic: groupLogic,
      conditions: uiConditions,
      name: group.name || `Group ${this.filterCriteriaDataService.groups.length + 1} Notes`,
      id: group.groupId || undefined,
      collapsed: false,
      isExpanded: true
    });
  }
}

/**
 * Recursively extract filter conditions from nested groups
 */
private extractFiltersRecursively(item: any, results: QueryCondition[]): void {
  if (item.type === 'Filter') {
    const reconstructedCondition = this.reconstructQueryCondition(item);
    results.push(reconstructedCondition);
  } else if (item.type === 'Group' && item.conditions) {
    for (const condition of item.conditions) {
      this.extractFiltersRecursively(condition, results);
    }
  }
}

/**
 * Legacy reconstruction for data saved without depth information
 */
private reconstructLegacyFormat(rootGroup: any): void {
  if (this.isAndGroup(rootGroup)) {
    this.handleAndGroup(rootGroup);
  } else if (this.isOrGroup(rootGroup)) {
    this.handleOrGroup(rootGroup);
  } else if (rootGroup.type === 'Filter') {
    this.handleFilterRoot(rootGroup);
  }
}

private isAndGroup(group: any): boolean {
  return group.type === 'Group' && group.operator === 'AND';
}

private isOrGroup(group: any): boolean {
  return group.type === 'Group' && group.operator === 'OR';
}

private handleAndGroup(rootGroup: any): void {
  if (!this.hasValidConditions(rootGroup)) return;
  
  for (const condition of rootGroup.conditions) {
    this.processAndGroupCondition(condition);
  }
}

private handleOrGroup(rootGroup: any): void {
  if (!this.hasValidConditions(rootGroup)) return;
  
  for (let i = 0; i < rootGroup.conditions.length; i++) {
    this.processOrGroupCondition(rootGroup.conditions[i], i);
  }
}

private hasValidConditions(group: any): boolean {
  return group.conditions && Array.isArray(group.conditions);
}

private processAndGroupCondition(condition: any): void {
  if (condition.type === 'Filter') {
    this.addFilterAsLegacyGroup(condition, 'AND');
  } else if (condition.type === 'Group') {
    this.addGroupAsLegacyGroup(condition, 'AND');
  }
}

private processOrGroupCondition(condition: any, index: number): void {
  const logic = index === 0 ? 'AND' : 'OR';
  
  if (condition.type === 'Group') {
    this.addGroupAsLegacyGroup(condition, logic);
  } else if (condition.type === 'Filter') {
    this.addFilterAsLegacyGroup(condition, logic);
  }
}

private addFilterAsLegacyGroup(condition: any, logic: 'AND' | 'OR'): void {
  const reconstructedCondition = this.reconstructQueryCondition(condition, 0, logic);
  this.filterCriteriaDataService.groups.push(this.createUIGroup(
    [reconstructedCondition],
    logic,
    condition.name || `Group ${this.filterCriteriaDataService.groups.length + 1} Notes`
  ));
}

private addGroupAsLegacyGroup(group: any, inheritedLogic: 'AND' | 'OR'): void {
  const uiConditions: QueryCondition[] = [];
  this.extractLegacyConditions(group.conditions, uiConditions, 0, group.operator);
  
  this.filterCriteriaDataService.groups.push(this.createUIGroup(
    uiConditions,
    'AND',
    group.name || `Group ${this.filterCriteriaDataService.groups.length + 1} Notes`,
    group.groupId
  ));
}

private handleFilterRoot(rootGroup: any): void {
  const reconstructedCondition = this.reconstructQueryCondition(rootGroup, 0, 'AND');
  this.filterCriteriaDataService.groups.push(this.createUIGroup(
    [reconstructedCondition],
    'AND',
    rootGroup.name || 'Group 1 Notes'
  ));
}

private createUIGroup(conditions: QueryCondition[], logic: 'AND' | 'OR', name: string, groupId?: string | null): ConditionGroup {
  return {
    logic,
    conditions,
    name,
    collapsed: false,
    isExpanded: true,
    id: groupId || undefined
  };
}

/**
 * Extract conditions from legacy format (no depth info), inferring depth from nesting
 */
private extractLegacyConditions(
  conditions: any[], 
  results: QueryCondition[], 
  depth: number, 
  logic: 'AND' | 'OR'
): void {
  if (!conditions || !Array.isArray(conditions)) return;
  
  for (let i = 0; i < conditions.length; i++) {
    const condition = conditions[i];
    
    if (condition.type === 'Filter') {
      const conditionLogic = i === 0 && depth === 0 ? 'AND' : logic;
      const reconstructedCondition = this.reconstructQueryCondition(condition, depth, conditionLogic);
      results.push(reconstructedCondition);
      
    } else if (condition.type === 'Group') {
      // Nested group - extract as children with increased depth
      this.extractLegacyConditions(
        condition.conditions, 
        results, 
        Math.min(depth + 1, 2),  // Max depth is 2
        condition.operator
      );
    }
  }
}

private reconstructConditionGroup(group: any): ConditionGroup {
  const conditionGroup = this.initializeConditionGroup(group);
  
  if (!this.hasGroupConditions(group)) return conditionGroup;
  
  for (const condition of group.conditions) {
    this.processConditionItem(condition, conditionGroup);
  }
  
  return conditionGroup;
}

private initializeConditionGroup(group: any): ConditionGroup {
  return {
    logic: 'AND',
    conditions: [],
    name: group.name || `Group ${this.filterCriteriaDataService.groups.length + 1} Notes`
  };
}

private hasGroupConditions(group: any): boolean {
  return group.conditions && Array.isArray(group.conditions);
}

private processConditionItem(condition: any, conditionGroup: ConditionGroup): void {
  if (condition.type === 'Filter') {
    this.addFilterToGroup(condition, conditionGroup);
  } else if (condition.type === 'Group' && condition.operator === 'OR') {
    this.addOrGroupToGroup(condition, conditionGroup);
  } else if (condition.type === 'Group' && condition.operator === 'AND') {
    this.addAndGroupToGroup(condition, conditionGroup);
  }
}

private addFilterToGroup(condition: any, conditionGroup: ConditionGroup): void {
  const reconstructedCondition = this.reconstructQueryCondition(condition);
  reconstructedCondition.logic = undefined;
  conditionGroup.conditions.push(reconstructedCondition);
}

private addOrGroupToGroup(condition: any, conditionGroup: ConditionGroup): void {
  this.processOrGroupFilters(condition.conditions, conditionGroup);
}

private addAndGroupToGroup(condition: any, conditionGroup: ConditionGroup): void {
  const nestedGroup = this.reconstructConditionGroup(condition);
  conditionGroup.conditions.push(...nestedGroup.conditions);
}

private processOrGroupFilters(conditions: any[], conditionGroup: ConditionGroup): void {
  for (let j = 0; j < conditions.length; j++) {
    const nestedCondition = conditions[j];
    if (nestedCondition.type === 'Filter') {
      this.addOrFilterToGroup(nestedCondition, j, conditionGroup);
    }
  }
}

private addOrFilterToGroup(condition: any, index: number, conditionGroup: ConditionGroup): void {
  const reconstructedCondition = this.reconstructQueryCondition(condition);
  if (index > 0) {
    reconstructedCondition.logic = 'OR';
  }
  conditionGroup.conditions.push(reconstructedCondition);
}


private buildBaseQueryCondition(condition: any, overrideDepth?: number, overrideLogic?: 'AND' | 'OR', isUsingTemplate?: boolean): QueryCondition {
  return {
    id: this.filterCriteriaDataService.generateConditionId(),
    field: this.filterCriteriaDataService.mapBackendFieldToFrontend(condition.field || ''),
    operator: this.filterCriteriaDataService.getOperatorsLabel(condition.operator || '='), 
    value: isUsingTemplate ? '' : this.convertValueFromBackend(condition.field || '', condition.value || ''),
    servicePartnerControl: new FormControl(''),
    depth: overrideDepth !== undefined ? overrideDepth : (condition.depth || 0),
    logic: overrideLogic !== undefined ? overrideLogic : (condition.logic || 'AND')
  };
}

private applyOptionalConditionFields(queryCondition: QueryCondition, condition: any, isUsingTemplate: boolean): void {
  if (condition.valueTo && !isUsingTemplate) {
    queryCondition.valueTo = condition.valueTo;
  }

  if (condition.excludedValues && !isUsingTemplate) {
    this.filterCriteriaDataService.excludedValuesMap[queryCondition.id] = condition.excludedValues;
    const hasIncludedValues = !this.isValueEmpty(queryCondition.value);
    if (hasIncludedValues) {
      queryCondition.operator = this.filterCriteriaDataService.getOperatorsLabel('=,!=');
    }
  }
}

private resolveCountryDisplayValues(rawValue: string): string[] {
  if (!rawValue) return [];

  const formatCountry = (code: string): string => {
    const country = this.countries?.find(c => c.id === code);
    if (!country) return code;
    return country.name && country.name.trim() !== '' ? `${country.name} (${country.id})` : country.id;
  };

  if (rawValue.includes(',')) {
    const codes = rawValue.split(',').map((v: string) => v.trim()).filter((v: string) => v);
    return codes.map(formatCountry);
  }

  return [formatCountry(rawValue.trim())];
}

private applyCountryFieldValue(queryCondition: QueryCondition, condition: any, isUsingTemplate: boolean): void {
  const rawValue = isUsingTemplate ? '' : (condition.value || '');
  queryCondition.value = this.resolveCountryDisplayValues(rawValue);
}

private applyServicePartnerFieldValue(queryCondition: QueryCondition, condition: any, isUsingTemplate: boolean): void {
  const partnerValue = isUsingTemplate ? '' : (condition.value || '');
  this.filterCriteriaDataService.partnerSearchTextMap[queryCondition.id] = partnerValue;
  queryCondition.servicePartnerControl?.setValue(partnerValue, { emitEvent: false });
  this.filterCriteriaDataService.filteredPartnerMap[queryCondition.id] = [];
}

private applySpecialFieldValues(queryCondition: QueryCondition, condition: any, isUsingTemplate: boolean): void {
  const fieldLower = queryCondition.field.toLowerCase();

  if (fieldLower === 'country') {
    this.applyCountryFieldValue(queryCondition, condition, isUsingTemplate);
  } else if (fieldLower === 'service partner') {
    this.applyServicePartnerFieldValue(queryCondition, condition, isUsingTemplate);
  }
}

private reconstructQueryCondition(condition: any, overrideDepth?: number, overrideLogic?: 'AND' | 'OR'): QueryCondition {
  const isUsingTemplate = this.dataService.selectedQuery?.filterType === QueryType.Template &&
                          this.dataService.ownerTemplateChoice === 'use';

  const queryCondition = this.buildBaseQueryCondition(condition, overrideDepth, overrideLogic, isUsingTemplate);
  this.applyOptionalConditionFields(queryCondition, condition, isUsingTemplate);
  this.applySpecialFieldValues(queryCondition, condition, isUsingTemplate);

  return queryCondition;
}

private resolveCountryConditionValue(condition: QueryCondition): void {
  if (!condition.value) return;

  if (typeof condition.value === 'string') {
    if (condition.value.includes(',')) {
      const countryValues = condition.value.split(',').map((name: string) => name.trim()).filter(Boolean);
      condition.value = countryValues.map((code: string) => {
        if (code.includes('(')) return code;
        const country = this.countries?.find(c => c.id === code);
        return country ? `${country.name} (${country.id})` : code;
      });
    } else {
      const code = condition.value.trim();
      if (code.includes('(')) {
        condition.value = [code];
      } else {
        const country = this.countries?.find(c => c.id === code);
        condition.value = [country ? `${country.name} (${country.id})` : code];
      }
    }
  } else if (Array.isArray(condition.value)) {
    condition.value = condition.value.map((v: string) => {
      if (v.includes('(')) return v;
      const country = this.countries?.find(c => c.id === v);
      return country ? `${country.name} (${country.id})` : v;
    });
  }
}

private resolveServicePartnerConditionValue(condition: QueryCondition): void {
  if (!condition.value) return;

  if (Array.isArray(condition.value)) {
    condition.value = condition.value.map((v: string) => String(v).trim()).filter(Boolean).join(',');
  }

  if (condition.servicePartnerControl) {
    condition.servicePartnerControl.setValue(String(condition.value));
  }
  this.filterCriteriaDataService.partnerSearchTextMap[condition.id] = String(condition.value);
  this.filterCriteriaDataService.filteredPartnerMap[condition.id] = [];
}

private resolveBusinessLineConditionValue(condition: QueryCondition): void {
  if (!condition.value) return;

  if (typeof condition.value === 'string') {
    if (condition.value.includes(',')) {
      const businessLineNames = condition.value.split(',').map((name: string) => name.trim()).filter((name: string) => name);
      condition.value = businessLineNames;
    } else {
      condition.value = [condition.value.trim()];
    }
  }
}

private resolveVasTypeConditionValue(condition: QueryCondition): void {
  if (!condition.value) return;

  if (typeof condition.value === 'string') {
    if (condition.value.includes(',')) {
      condition.value = condition.value.split(',').map((v: string) => v.trim()).filter((v: string) => v);
    } else {
      condition.value = [condition.value.trim()];
    }
  }
}

private resolveVasLevelConditionValue(condition: QueryCondition): void {
  if (!condition.value) return;

  if (typeof condition.value === 'string') {
    if (condition.value.includes(',')) {
      condition.value = condition.value.split(',').map((v: string) => v.trim()).filter((v: string) => v);
    } else {
      condition.value = [condition.value.trim()];
    }
  }
}

private resolveCiStatusConditionValue(condition: QueryCondition): void {
  if (!condition.value) return;

  if (typeof condition.value === 'string') {
    const rawValues = condition.value.split(',').map((v: string) => v.trim()).filter((v: string) => v);
    const canonicalValues = new Set<string>();
    for (const raw of rawValues) {
      canonicalValues.add(this.getCanonicalDisplayValue('eqstatus', raw));
    }
    condition.value = Array.from(canonicalValues);
  }
}

private resolveCiSubstatusConditionValue(condition: QueryCondition): void {
  if (!condition.value) return;

  if (typeof condition.value === 'string') {
    const rawValues = condition.value.split(',').map((v: string) => v.trim()).filter((v: string) => v);
    const canonicalValues = new Set<string>();
    for (const raw of rawValues) {
      canonicalValues.add(this.getCanonicalDisplayValue('eqsubstatus', raw));
    }
    condition.value = Array.from(canonicalValues);
  }
}

private resolveConditionDisplayValue(condition: QueryCondition): void {
  const fieldLower = condition.field.toLowerCase();

  const fieldResolvers: Record<string, (queryCondition: QueryCondition) => void> = {
    'country':        (queryCondition) => this.resolveCountryConditionValue(queryCondition),
    'service partner':(queryCondition) => this.resolveServicePartnerConditionValue(queryCondition),
    'business line':  (queryCondition) => this.resolveBusinessLineConditionValue(queryCondition),
    'vas type':       (queryCondition) => this.resolveVasTypeConditionValue(queryCondition),
    'vas level':      (queryCondition) => this.resolveVasLevelConditionValue(queryCondition),
    'eq status':      (queryCondition) => this.resolveCiStatusConditionValue(queryCondition),
    'eq substatus':   (queryCondition) => this.resolveCiSubstatusConditionValue(queryCondition),
  };

  const resolver = fieldResolvers[fieldLower];
  if (resolver) {
    resolver(condition);
  }
}

private resolveAllGroupConditionDisplayValues(): void {
  for (const group of this.filterCriteriaDataService.groups) {
    for (const condition of group.conditions) {
      this.resolveConditionDisplayValue(condition);
    }
  }
}

private triggerDisplayRefresh(): void {
  setTimeout(() => {
    this.cdr.detectChanges();
    setTimeout(() => {
      this.filterCriteriaDataService.syncMultiselectDropdowns(this.elementRef);
    }, 50);
  }, 50);
}

private populateSpecialFieldData(): void {
  setTimeout(() => {
    this.resolveAllGroupConditionDisplayValues();
    this.filterCriteriaDataService.updateVasLevelOptions(this.elementRef);
    this.triggerDisplayRefresh();
  }, 100);
}


private updateSharedService(): void {
  this.sharedService.updateFilterFormData({
    notes: this.notes,
    commonTemplate: '' // You may want to get this from a form field if it exists
  });
}

private captureCurrentState(): void {
  this.originalState = {
    notes: this.notes,
    groups: this.serializeGroupsForComparison()
  };
}


private serializeGroupsForComparison(): string {
  const cleanGroups = this.filterCriteriaDataService.groups.map(group => ({
    logic: group.logic,
    name: group.name || '',
    conditions: group.conditions.map(conditions => {
      let normalizedValue = conditions.value;
      if (Array.isArray(normalizedValue)) {
        // Deduplicate AND sort using localeCompare for reliable alphabetical ordering
        normalizedValue = [...new Set(normalizedValue)]
          .sort((a: string, b: string) => a.localeCompare(b))
          .join(',');
      } else if (typeof normalizedValue === 'string') {
        const parts = normalizedValue.split(',').map(v => v.trim()).filter(v => v);
        // Deduplicate AND sort using localeCompare for reliable alphabetical ordering
        normalizedValue = [...new Set(parts)]
          .sort((a: string, b: string) => a.localeCompare(b))
          .join(',');
      }

      return {
        field: conditions.field,
        operator: conditions.operator,
        value: normalizedValue,
        valueTo: conditions.valueTo || '',
        logic: conditions.logic,
        excludedValues: this.filterCriteriaDataService.excludedValuesMap[conditions.id] || ''
      };
    })
  }));
  return JSON.stringify(cleanGroups);
}


public hasChanges(): boolean {
  const currentState = {
    notes: this.notes,
    groups: this.serializeGroupsForComparison()
  };

  const hasChanges = 
    currentState.notes !== this.originalState.notes ||
    currentState.groups !== this.originalState.groups;

    if (hasChanges) {
    this.isNewFilterSaved = false;
  }
  return hasChanges;
}

public autoSaveIfChanged(): Promise<boolean> {
  return new Promise((resolve) => {
    if (!this.hasChanges()) {
      this.notification = {
        label: 'Info',
        description: 'No changes to save.',
        type: 'info'
      };
      resolve(true);
      return;
    }

    this.notification = {
      label: 'Saving',
      description: 'Saving filter criteria...',
      type: 'info'
    };

    this.performAutoSave().then((success) => {
      if (success) {
        this.captureCurrentState();
      }
      resolve(success);
    });
  });
}

private performAutoSave(): Promise<boolean> {
  return new Promise((resolve) => {
    try {
      const projectId = this.dataService.projectId;
      
      if (!projectId) {
        console.error('Project ID is required to auto-save filter criteria');
        resolve(false);
        return;
      }

      const filterPayload = this.preparePayload();
      
      this.updateSharedService();
      const filterFormData = this.sharedService.getFilterFormData();

      const request: any = {
        projectId: projectId,
        commonTemplate: filterFormData.commonTemplate || '',
        comments: filterFormData.notes || '',
        rootGroup: JSON.stringify(filterPayload.rootGroup)
      };


      this.filterCriteriaService.saveFilterCriteria(request).subscribe({
        next: (response) => {
          this.captureCurrentState(); 
          this.notification = {
            label: 'Success',
            description: 'Filter criteria saved successfully!',
            type: 'success'
          };
          this.originalGroups = JSON.parse(JSON.stringify(this.filterCriteriaDataService.groups));
          resolve(true);
        },
        error: (error) => {
          console.error('Error auto-saving filter criteria:', error);
          let errorMessage = 'Failed to save filter criteria. Please try again.';
          
          if (error?.error?.message) {
            errorMessage = error.error.message;
          } else if (error?.message) {
            errorMessage = error.message;
          }
          
          this.notification = {
            label: 'Error',
            description: errorMessage,
            type: 'error'
          };
          resolve(false);
        }
      });
    } catch (error) {
      console.error('Error in auto-save:', error);
      resolve(false);
    }
  });
}

private hasValidFilterConditions(filterPayload: FilterPayload): boolean {
  if (!filterPayload || !filterPayload.rootGroup) {
    return false;
  }

  return this.groupHasValidConditions(filterPayload.rootGroup);
}

private groupHasValidConditions(group: any): boolean {
  if (!group || !group.conditions || !Array.isArray(group.conditions)) {
    return false;
  }

  if (group.conditions.length === 0) {
    return false;
  }

  for (const condition of group.conditions) {
    if (condition.type === 'Filter') {
      if (condition.field && condition.operator && condition.value !== undefined && condition.value !== null && condition.value !== '') {
        return true;
      }
    } else if (condition.type === 'Group') {
      if (this.groupHasValidConditions(condition)) {
        return true;
      }
    }
  }

  return false;
}

  onClickTab(tabName: string) {
    this.summaryTitle = tabName === QUERY_TYPE.MANUAL_QUERY ? 'Summary' : 'Query';
    this.selectedTab = tabName;
    this.onRefreshSummary();
    // Notify SharedService about tab switch to clear results
    this.sharedService.notifyTabSwitch(tabName === QUERY_TYPE.MANUAL_QUERY ? 'manual' : 'llm');
  }

  onCreatingManualQuery() {
    this.filterCriteriaService.createManualQueryLLM(this.llmQueryText).subscribe({
      next: (response) => {
        this.generatedSQLQuery = response.generated_sql.split('WHERE')[1];
        this.querySummary = [{ text: this.generatedSQLQuery, nested: false }];
        this.handlePopulatingGroups(JSON.parse(response.manualQuery));
        this.onClickTab(QUERY_TYPE.MANUAL_QUERY);
    },
      error: (error) => {
        console.error('Error testing LLM query:', error);
      }
    });
  }

  onTestRunLLMQuery() {
    this.filterCriteriaService.createManualQueryLLM(this.llmQueryText).subscribe({
      next: (response) => {
        this.generatedSQLQuery = response.generated_sql.split('WHERE')[1];
        this.llmManualQuery = response.manualQuery; // Store for test run
        this.querySummary = [{ text: this.generatedSQLQuery, nested: false }];
      },
      error: (error) => {
        console.error('Error testing LLM query:', error);
      }
    });
  }

  testRunLLMQuery() {
    if (!this.llmManualQuery) {
      return;
    }

    try {
      const parsedQuery = JSON.parse(this.llmManualQuery);
      const payload: FilterPayload = {
        rootGroup: parsedQuery
      };
      this.sharedService.triggerTestRun(payload, 'llm');
      setTimeout(() => {
        const anchor = document.getElementById('volume-table-anchor');
        if (anchor) {
          anchor.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }, 100);
    } catch (error) {
      console.error('Error parsing LLM manual query:', error);
    }
  }

  handlePopulatingGroups(responseData: any) {
    if (responseData) {
      this.notes = '';

      if (responseData) {
        try {
          const parsedRootGroup = typeof responseData === 'string'
            ? JSON.parse(responseData)
            : responseData;

          this.reconstructFiltersFromRootGroup(parsedRootGroup);

          this.populateSpecialFieldData();
          this.filterCriteriaDataService.updateContractOptions();
        } catch (error) {
          console.error('Error parsing saved filter:', error);
        }
      }
    }
  }

  changeLLMQueryText(llmLatestValue: string) {
    this.llmQueryText = llmLatestValue;
  }
  
  openSaveModel() {
  this.savedFilterType = 'Standard'; 
  this.filterName = '';
  this.comments = '';
  this.descriptionError = '';
  this.isModalVisible = true;
}

openSaveAsModal() {
  this.whichFilterType = 'Standard';
  this.filterName = '';
  this.inputProjectId = '';
  this.comments = '';
  this.descriptionError = '';
  this.isSaveAsModalVisible = true;
}

  onDescriptionInput(): void {
    this.validateDescription();
  }

  private validateDescription(): boolean {
    if ((this.comments ?? '').length > this.MAX_DESCRIPTION_LENGTH) {
      this.descriptionError = `Text exceeds ${this.MAX_DESCRIPTION_LENGTH} characters (current: ${this.comments.length}). Please reduce the content before saving`;
      return false;
    }

    this.descriptionError = '';
    return true;
  }

  onSaveAsStandard() {
    this.saveUserFilterOrder(QueryType.Standard);
  }

  onSaveAsProject() {
       this.saveUserFilterOrder(QueryType.Project);
  }

  onSaveAsTemplate() {
    this.saveUserFilterOrder(QueryType.Template);
  }

  private validateProjectFilterFormat(filterName: string): { isValid: boolean, errorMessage: string } {
    const projectFormatRegex = /^UP\.[A-Z]{2}-\d{5}$/;
    
    if (!projectFormatRegex.test(filterName)) {
      return {
        isValid: false,
        errorMessage: 'Invalid format. Expected: UP.BL-YY### (e.g., UP.CT-25445)'
      };
    }
    
    return {
      isValid: true,
      errorMessage: ''
    };
  }

  private saveUserFilterOrder(type: SaveFilterType) {
    if (!this.validateDescription()) {
      this.notification = { description: '', label: '', type: '' };

      setTimeout(() => {
        this.notification = {
          label: 'Error',
          description: this.descriptionError,
          type: 'error',
        };
      }, 10);
      return;
    }

    if (!this.filterName || this.filterName.trim() === '') {
      this.notification = { description: '', label: '', type: '' };
      
      setTimeout(() => {
        this.notification = {
          label: 'Error',
          description: 'Please enter a filter name',
          type: 'error',
        };
      }, 10);
      return;
    }
  
    if (type === QueryType.Project) {
      const validation = this.validateProjectFilterFormat(this.filterName.trim());
      if (!validation.isValid) {
        this.notification = { description: '', label: '', type: '' };
        
        setTimeout(() => {
          this.notification = {
            label: 'Error',
            description: validation.errorMessage,
            type: 'error',
          };
        }, 10);
        return;
      }
    }
  
    // Start loader before API sequence
    this.isSaving = true;
    this.checkFilterNameAndSave(type);
  }
  
  private checkFilterNameAndSave(type: SaveFilterType): void {
    this.filterCriteriaService.checkFilterName(this.filterName.trim(), type).subscribe({
      next: (response) => {
        if (response === true) {
          // Name already exists, show error
          this.notification = { description: '', label: '', type: '' };
          
          setTimeout(() => {
            this.notification = {
              label: 'Error',
              description: `Filter name "${this.filterName.trim()}" already exists. Please choose a different name.`,
              type: 'error',
            };
          }, 10);
          this.isSaving = false;
        } else if (response === false) {
          this.proceedWithSave(type);
        } else {
          console.warn('Unexpected response format from checkFilterName:', response);
          this.proceedWithSave(type);
        }
      },
      error: (error) => {
        console.error('Error checking filter name:', error);
        this.notification = { description: '', label: '', type: '' };
        
        setTimeout(() => {
          this.notification = {
            label: 'Error',
            description: 'Error checking filter name. Please try again.',
            type: 'error',
          };
        }, 10);
        this.isSaving = false;
      }
    });
  }
  
  private proceedWithSave(type: SaveFilterType): void {
  const userEmail = this.dataService.profile.mail;
  const filterPayload = this.preparePayload();

  let hasValue: boolean = false;
    if (type === 'Template') {
      hasValue = this.isSaveWithValues;
    }
  
  const filterData: QueryFilter = {
    Name: this.filterName.trim(),
    Email: userEmail,
    Type: type,
    query: JSON.stringify(filterPayload.rootGroup), 
    comments: this.comments,
    versionNo: this.updatedVersion,
    GlobalQuery: this.createGlobalQuery(),
    ProjectId: this.inputProjectId.trim(),
    HasValue: hasValue,
    isDefault:(type === 'Template' || type === 'Public_Template') ? this.isDefaultQuery : false,
    isFavourite: this.setAsFavoriteFilter
  };

  this.filterCriteriaService.saveUserFilter(filterData).subscribe({
    next: (response) => {
      const savedFilterDetails = response.filterDetails
      this.updateGUIDAndVersion(savedFilterDetails);
      this.captureCurrentState();
      this.dataService.selectedFilterName = this.filterName.trim();
      this.isModalVisible = false;
      this.isSaveAsModalVisible = false;
      this.filterName = '';
      this.inputProjectId = ''; 
      this.comments = '';
      this.savedFilterType = 'Standard';
      this.isDefaultQuery = false;
      this.isNewFilterSaved = true;
      this.notification = { description: '', label: '', type: '' };
      setTimeout(() => {
        this.notification = {
          label: 'Success',
          description: response.message,
          type: 'success',
        };
      }, 10);
      this.isSaving = false;
       
    },
    error: (error) => {  
      this.notification = { description: '', label: '', type: '' };
      
      setTimeout(() => {
        this.notification = {
          label: 'Error',
          description: 'Error saving filter. Please try again.',
          type: 'error',
        };
      }, 10);
      this.isSaving = false;
    }
  });
}

  onSaveAs() {
    if (!this.whichFilterType) {
      this.notification = { description: '', label: '', type: '' };
      setTimeout(() => {
        this.notification = {
          label: 'Error',
          description: 'Please select a filter type (Standard, Project, or Template).',
          type: 'error',
        };
      }, 10);
      return;
    }
    this.saveUserFilterOrder(this.whichFilterType);
  }

 onSaveQueryFilter(): void {
    if (!this.savedFilterType) {
      this.notification = { description: '', label: '', type: '' };
      setTimeout(() => {
        this.notification = {
          label: 'Error',
          description: 'Please select a filter type (Standard, Project, or Template).',
          type: 'error',
        };
      }, 10);
      return;
    }
    this.saveUserFilterOrder(this.savedFilterType);
}
  
  onSave(isClear = false): void {
    if (!this.currentFilterGuid) {
      this.notification = { description: '', label: '', type: '' };
      
      setTimeout(() => {
        this.notification = {
          label: 'Error',
          description: 'No filter loaded to update',
          type: 'error',
        };
      }, 10);
      return;
    }

    if (!this.hasChanges()) {
      this.notification = { description: '', label: '', type: '' };
      
      setTimeout(() => {
        this.notification = {
          label: 'Info',
          description: 'No changes to save',
          type: 'info',
        };
      }, 10);
      return;
    }

    this.notification = {
      label: 'Saving',
      description: 'Updating filter...',
      type: 'info'
    };

    const filterPayload = this.preparePayload();
    const userEmail = this.dataService.profile.mail;
    let hasValue: boolean = false;
    if (this.dataService.selectedQuery?.filterType === QueryType.Template) {
      hasValue = this.isSaveWithValues;
    }
    const filterData: QueryFilter = {
      Name: this.dataService.selectedQuery?.name || '',
      Email: userEmail,
      Type: '',
      query: JSON.stringify(filterPayload.rootGroup),
      comments: this.comments,
      versionNo: this.updatedVersion,
      GlobalQuery: this.createGlobalQuery(),
      ProjectId: this.dataService.selectedQuery?.projectId || '',
      HasValue: hasValue,
      isDefault:(this.savedFilterType === 'Template' || this.savedFilterType === 'Public_Template') ? this.isDefaultQuery : false,
      isFavourite: this.setAsFavoriteFilter
    };

    this.filterCriteriaService.updateCurrentVersion(this.currentFilterGuid, filterData).subscribe({
      next: () => {
        this.captureCurrentState();
        
        this.notification = { description: '', label: '', type: '' };
        setTimeout(() => {
          this.notification = {
            label: 'Success',
            description: 'Filter updated successfully',
            type: 'success',
          };
        }, 10);
        //If saving and clearing...
        if (isClear) {
          this.openClearConfirmModal = false;
          this.resetGroups();
        }
      },
      error: (error) => {
        console.error('Error updating filter:', error);
        let errorMessage = 'Failed to update filter. Please try again.';
        
        if (error?.error?.message) {
          errorMessage = error.error.message;
        } else if (error?.message) {
          errorMessage = error.message;
        }
        
        this.notification = { description: '', label: '', type: '' };
        setTimeout(() => {
          this.notification = {
            label: 'Error',
            description: errorMessage,
            type: 'error',
          };
        }, 10);
      }
    });
  }

  private sanitizeInput(event: any, property: 'filterName' | 'inputProjectId'): void {
    const input = event.target.value; 
    const validPattern = /^[a-zA-Z0-9\s\-_.,()\&]*$/;

    if (!validPattern.test(input)) {
      this[property] = input.replace(/[^a-zA-Z0-9\s\-_.,()\&]/g, '');
      event.target.value = this[property];
    }
  }

  onSaveRestriction(event: any): void {
    this.sanitizeInput(event, 'filterName');
  }

  onSaveRestrictionForProjectId(event: any): void {
    this.sanitizeInput(event, 'inputProjectId');
  }


  isClickManualQuery() {
    return this.selectedTab === QUERY_TYPE.MANUAL_QUERY;
  }

  isClickLLMQuery() {
    return this.selectedTab === QUERY_TYPE.LLM_QUERY;
  }

  clearAllFilters() {
    if (this.openClearConfirmModal) {
      return;
    }
    //1. No changes and 2. Changes but saved
    if (!this.hasChanges() || (this.hasChanges() && this.isFiltersSaved())) {
      this.resetGroups();
    } 
    //3. Changes but not saved
    else if(this.hasChanges() && !this.isFiltersSaved()) {
      this.openClearConfirmModal = true;
    }
  }

  clearOnlyValues() {
    const groups = this.filterCriteriaDataService.groups ?? [];

    groups.forEach((group) => {
      group?.conditions?.forEach((condition) => {
        if (!condition) {
          return;
        }

        condition.value = Array.isArray(condition.value) ? [] : '';
        condition.valueTo = '';

        if (condition.field === 'Service Partner') {
          this.filterCriteriaDataService.partnerSearchTextMap[condition.id] = '';
          this.filterCriteriaDataService.filteredPartnerMap[condition.id] = [];
          condition.servicePartnerControl?.setValue('', { emitEvent: false });
        }

        if (this.filterCriteriaDataService.isMaterialNoField?.(condition.field)) {
          delete this.filterCriteriaDataService.ivkMap[condition.id.toString()];
          this.filterCriteriaDataService.ivkLoadingMap[condition.id.toString()] = false;
        }

        delete this.filterCriteriaDataService.excludedValuesMap[condition.id];
      });
    });

    this.filterCriteriaDataService.updateContractOptions();
    this.filterCriteriaDataService.updateScrollAreaHeight();
  }

  isFiltersSaved(): boolean {
    return this.dataService.compareTwoObjects(this.originalGroups, this.filterCriteriaDataService.groups);
  }

  onDiscardClear() {
    this.openClearConfirmModal = false;
    this.resetGroups();
  }

  onSaveClear() {
    this.onSave(true);
  }
  
  resetGroups() {
    this.filterCriteriaDataService.groups = [{
      logic: 'AND',
      conditions: [
        {
          id: 1,
          field: '',
          operator: '',
          value: '',
          servicePartnerControl: new FormControl('')
        }
      ],
      id: this.filterCriteriaDataService.generateGroupId()
    }];
    this.filterCriteriaDataService.updateContractOptions();
    this.filterCriteriaDataService.updateScrollAreaHeight();
  }

  hasOwnerAndTemplateRights() {
    if (this.dataService.selectedQuery?.filterType === QueryType.Template) {
      return (
        this.dataService.profile.mail === this.dataService.selectedQuery?.email &&
        this.dataService.profile.accessRole.includes(USER_TYPE.SUPPORT_USER) && this.dataService.ownerTemplateChoice === 'edit'
      );
    } else {
      return true;
    }
  }

  openExpandModal() {
    this.expandManualQuery = !this.expandManualQuery;
  }
  
  checkAccessRole(role: string): boolean {
    return this.dataService.profile.accessRole?.includes(role);
  }


   onSaveCurrentVersion(callback?: () => void, errorCallback?: () => void): void {
    if (!this.currentFilterGuid) {
      this.notification = { description: '', label: '', type: '' };
      setTimeout(() => {
        this.notification = {
          label: 'Error',
          description: 'No filter loaded to update.',
          type: 'error',
        };
      }, 10);
      return;
    }

    if (!this.hasChanges() && !callback) {
      this.notification = { description: '', label: '', type: '' };
      setTimeout(() => {
        this.notification = {
          label: 'Info',
          description: 'No changes to save.',
          type: 'info',
        };
      }, 10);
      return;
    }

    const filterPayload = this.preparePayload();
    const userEmail = this.dataService.profile.mail;

    const filterData: QueryFilter = {
      Name: this.dataService.selectedQuery?.name || '',
      Email: userEmail,
      Type: '',
      query: JSON.stringify(filterPayload.rootGroup),
      comments: this.comments,
      versionNo: this.updatedVersion,
      GlobalQuery: this.createGlobalQuery(),
       ProjectId: this.dataService.selectedQuery?.projectId || '',
      HasValue: this.dataService.selectedQuery?.filterType === QueryType.Template ? this.isSaveWithValues : false,
      isDefault:(this.savedFilterType === 'Template' || this.savedFilterType === 'Public_Template') ? this.isDefaultQuery : false,
      isFavourite: this.setAsFavoriteFilter
    };

     this.filterCriteriaService.updateCurrentVersion(this.currentFilterGuid, filterData).subscribe({
      next: () => {
        this.captureCurrentState();
        this.showUnsavedChangesModal = false;
        this.notification = { description: '', label: '', type: '' };
        setTimeout(() => {
          this.notification = {
            label: 'Success',
            description: 'Filter updated successfully.',
            type: 'success',
          };
        }, 10);
        if (callback) callback();
      },
      error: (error) => {
        console.error('Error saving current version:', error);
        this.showUnsavedChangesModal = true;
        this.notification = { description: '', label: '', type: '' };
        setTimeout(() => {
          this.notification = {
            label: 'Error',
            description: error?.error?.message || 'Failed to save changes. Please try again.',
            type: 'error',
          };
        }, 10);
        if (errorCallback) errorCallback();
      }
    });
  }

  isTemplateFilter(): boolean {
    const filterType = this.dataService.selectedQuery?.filterType?.toLowerCase();
    return filterType === 'template' || filterType === 'public_template';
  }

  onSaveNewVersion(callback?: () => void, errorCallback?: () => void): void {
    if (!this.currentFilterGuid) {
      this.notification = { description: '', label: '', type: '' };
      setTimeout(() => {
        this.notification = {
          label: 'Error',
          description: 'No filter loaded to create a new version.',
          type: 'error',
        };
      }, 10);
      return;
    }

    const filterPayload = this.preparePayload();
    const userEmail = this.dataService.profile.mail;

    const filterData: QueryFilter = {
      Name: this.dataService.selectedQuery?.name || '',
      Email: userEmail,
      Type: this.dataService.selectedQuery?.filterType || 'Standard',
      query: JSON.stringify(filterPayload.rootGroup),
      comments: this.comments,
      versionNo: this.updatedVersion,
      GlobalQuery: this.createGlobalQuery(),
       ProjectId: this.dataService.selectedQuery?.projectId || '',
      HasValue: this.dataService.selectedQuery?.filterType === QueryType.Template ? this.isSaveWithValues : false,
      isDefault:(this.savedFilterType === 'Template' || this.savedFilterType === 'Public_Template') ? this.isDefaultQuery : false,
    };

    this.isSaving = true;

    // For templates, update current version instead of creating a new version
    if (this.isTemplateFilter()) {
      this.filterCriteriaService.updateCurrentVersion(this.currentFilterGuid, filterData).subscribe({
        next: () => {
          this.captureCurrentState();
          this.isSaving = false;
          this.notification = { description: '', label: '', type: '' };
          setTimeout(() => {
            this.notification = {
              label: 'Success',
              description: 'Template updated successfully.',
              type: 'success',
            };
          }, 10);
          if (callback) callback();
        },
        error: (error) => {
          console.error('Error updating template:', error);
          this.isSaving = false;
          if (errorCallback) errorCallback();
          this.notification = { description: '', label: '', type: '' };
          setTimeout(() => {
            this.notification = {
              label: 'Error',
              description: error?.error?.message || 'Failed to update template. Please try again.',
              type: 'error',
            };
          }, 10);
        }
      });
      return;
    }

    this.filterCriteriaService.saveAsNewVersion(this.currentFilterGuid, filterData).subscribe({
      next: (response) => {
        const newVersion = response?.message?.match(/V\d{3}/)?.[0] || '';
        if (newVersion) {
          this.updatedVersion = newVersion;
          if (this.dataService.selectedQuery) {
            this.dataService.selectedQuery.versionNo = newVersion;
          }
        }
        this.captureCurrentState();
        this.isSaving = false;
        this.notification = { description: '', label: '', type: '' };
        setTimeout(() => {
          this.notification = {
            label: 'Success',
            description: `New version ${this.formatVersion(newVersion) || ''} created successfully.`,
            type: 'success',
          };
        }, 10);
        if (callback) callback();
      },
      error: (error) => {
        console.error('Error creating new version:', error);
        this.isSaving = false;
        if (errorCallback) errorCallback();
        let errorMessage = 'Failed to create new version. Please try again.';
        if (error?.error?.details?.includes('Maximum version limit')) {
          errorMessage = 'Maximum version limit (V999) reached. Cannot create more versions.';
        }
        this.notification = { description: '', label: '', type: '' };
        setTimeout(() => {
          this.notification = {
            label: 'Error',
            description: errorMessage,
            type: 'error',
          };
        }, 10);
      }
    });
  }

 isCreatedByCurrentUser(): boolean {
  if (!this.dataService.selectedQuery) {
    return true;
  }
  
  if (!this.dataService.profile) {
    return false;
  }
  
  return this.dataService.selectedQuery.email === this.dataService.profile.mail;
}

// â”€â”€ Template Modal Methods â”€â”€

openTemplateModal(tab?: 'template' | 'query'): void {
  if (tab) {
    this.activeTab = tab;
  }
  this.showTemplateModal = true;
  this.loadTemplates();
}

closeTemplateModal(): void {
  this.showTemplateModal = false;
  this.selectedTemplateItem = null;
  this.clearTemplateSearchFilters();
  this.showTemplateColumnVisibilityPopup = false;
  this.isTemplateOthersSearchLoading = false;
  this.isShowingTemplateOthersResults = false;
  this.queryGlobalSearchText = '';
  this.isQueryOthersSearchLoading = false;
  this.isShowingQueryOthersResults = false;
}

loadTemplates(): void {
  this.isLoadingTemplates = true;
  this.filterCriteriaService.getAllQuery().subscribe({
    next: (response) => {
      let uidCounter = 0;
      const templates = (response.templateFilter || []).map((t: any) => ({
        _uid: uidCounter++,
        id: t.id || '',
        name: t.name || '',
        type: t.type?.toLowerCase() === QueryType.Public_Template.toLowerCase() ? 'Public' : 'Personal',
        comments: t.comments || '',
        query: t.query || '',
        globalQuery: t.globalQuery || '',
        projectId: t.projectId || '',
        version: t.version || '',
        email: t.email || '',
        guid: t.guid || '',
        isFavourite: t.isFavourite || false
      }));
      
      const queries = (response.query || []).map((t: any) => ({
        _uid: uidCounter++,
        id: t.id || '',
        name: t.name || '',
        comments: t.comments || '',
        query: t.query || '',
        globalQuery: t.globalQuery || '',
        projectId: t.projectId || '',
        version: t.version || '',
        email: t.email || '',
        guid: t.guid || '',
        isFavourite: t.isFavourite || false
      }));
      const seenGuids = new Set<string>();
      this.templateList = this.sortTemplatesForDisplay([
        ...templates,
      ]).filter((template) => {
        if (!template.guid || seenGuids.has(template.guid)) {
          return false;
        }
        seenGuids.add(template.guid);
        return true;
      });;
      this.myTemplateList = [...this.templateList];
      this.filteredTemplateList = [...this.templateList];
      this.allQueries = this.sortQueriesByFavoriteAndName(queries);
      this.myQueryList = [...this.allQueries];
      this.filteredQueries = [...this.allQueries];
      this.isLoadingTemplates = false;
    },
    error: (error) => {
      console.error('Error loading templates:', error);
      this.isLoadingTemplates = false;
      this.notification = {
        label: 'Error',
        description: 'Failed to load templates',
        type: 'error'
      };
    }
  });
}

onTemplateSearch(resetOthersResults: boolean = true): void {
  if (resetOthersResults && this.isShowingTemplateOthersResults) {
    this.isShowingTemplateOthersResults = false;
    this.templateList = [...this.myTemplateList];
  }

  const normalizedGlobalSearch = (this.templateGlobalSearchText || '').trim().toLowerCase();
  const selectedColumns = this.getTemplateSearchColumns();

  const filteredTemplates = this.templateList.filter(template => {
    const idMatch = !this.templateIdSearchText ||
      String(template.id ?? '').toLowerCase().includes(this.templateIdSearchText.toLowerCase());
    const nameMatch = !this.templateNameSearchText ||
      template.name?.toLowerCase().includes(this.templateNameSearchText.toLowerCase());
    const typeMatch = !this.templateTypeSearchText ||
      this.templateTypeSearchText.toLowerCase().includes(template?.type.toLowerCase());
    const commentsMatch = !this.templateCommentsSearchText ||
      template.comments?.toLowerCase().includes(this.templateCommentsSearchText.toLowerCase());
    const globalMatch = !normalizedGlobalSearch ||
      selectedColumns.some((columnKey) => this.getTemplateColumnValue(template, columnKey).includes(normalizedGlobalSearch));

    return idMatch && nameMatch && typeMatch && commentsMatch && globalMatch;
  });

    this.filteredTemplateList = this.sortTemplatesForDisplay(filteredTemplates);
}

clearTemplateSearchFilters(): void {
  this.templateIdSearchText = '';
  this.templateNameSearchText = '';
  this.templateTypeSearchText = '';
  this.templateCommentsSearchText = '';
  this.templateGlobalSearchText = '';
  this.templateSearchColumnsValue = FilterCriteriaComponent.DEFAULT_TEMPLATE_SEARCH_COLUMNS.join(',');
  this.isShowingTemplateOthersResults = false;
  this.templateList = [...this.myTemplateList];
  this.filteredTemplateList = this.sortTemplatesForDisplay([...this.templateList]);
}

onTemplateGlobalSearchInput(event: Event): void {
  const inputTarget = event.target as HTMLInputElement | null;
  this.templateGlobalSearchText = inputTarget?.value ?? '';
  this.onTemplateSearch();
}

onTemplateGlobalSearchClear(): void {
  this.templateGlobalSearchText = '';
  this.onTemplateSearch();
}

onTemplateSearchColumnChange(event: Event): void {
  const selectedColumns = this.resolveTemplateColumnSelection(event);
  this.templateSearchColumnsValue = selectedColumns.length > 0
    ? selectedColumns.join(',')
    : FilterCriteriaComponent.DEFAULT_TEMPLATE_SEARCH_COLUMNS.join(',');
  this.onTemplateSearch();
}

onTemplateSearchOthers(): void {
  const searchTerm = (this.templateGlobalSearchText || '').trim();
  if (!searchTerm) {
    return;
  }

  this.isTemplateOthersSearchLoading = true;
  this.isShowingTemplateOthersResults = false;

  this.landingPageService.searchFilters(searchTerm, true).subscribe({
    next: (results) => {
      this.isTemplateOthersSearchLoading = false;

      this.templateList = (results || []).map((template: any, index: number) => ({
        _uid: index,
        id: template?.id || '',
        name: template?.name || '',
        type: template?.type === QueryType.Public_Template ? 'Public' : 'Personal',
        comments: template?.comments || '',
        query: template?.query || template?.filter || '',
        globalQuery: template?.globalQuery || template?.globalFilter || '',
        projectId: template?.projectId || '',
        version: template?.version || template?.versionNo || '',
        email: template?.email || '',
        guid: template?.guid || ''
      }));

      this.selectedTemplateItem = null;
      this.isShowingTemplateOthersResults = true;
      this.filteredTemplateList = [...this.templateList];
      this.onTemplateSearch(false);
    },
    error: () => {
      this.isTemplateOthersSearchLoading = false;
      this.isShowingTemplateOthersResults = true;
      this.templateList = [];
      this.filteredTemplateList = [];
      this.notification = {
        label: 'Error',
        description: 'Failed to search templates.',
        type: 'error'
      };
    }
  });
}

toggleTemplateColumnVisibilityPopup(): void {
  this.showTemplateColumnVisibilityPopup = !this.showTemplateColumnVisibilityPopup;
}

onTemplateColumnVisibilityChange(columnToToggle: any, event: any): void {
  const columnIndex = this.templateTableColumns.findIndex(column => column.key === columnToToggle.key);
  if (columnIndex < 0) {
    return;
  }
  const isActive = event.target.active;
  this.templateTableColumns[columnIndex].visible = isActive;
}

isTemplateColumnVisible(columnKey: string): boolean {
  return this.templateTableColumns.find(column => column.key === columnKey)?.visible ?? true;
}

onTemplateRadioChange(template: any): void {
  this.selectedTemplateItem = template;
}

loadSelectedTemplate(): void {
  if (!this.selectedTemplateItem) {
    return;
  }

  const templateToLoad = this.selectedTemplateItem;

  if (this.hasChanges()) {
    this.pendingVersionToLoad = { ...templateToLoad, _isTemplate: true };
    this.showUnsavedChangesModal = true;
    this.closeTemplateModal();
    return;
  }

  this.proceedWithLoadingTemplate(templateToLoad);
}

private proceedWithLoadingTemplate(templateToLoad: any): void {
  try {
    if (templateToLoad.guid === this.currentFilterGuid) {
      const itemType = templateToLoad._isQuery ? 'Query' : 'Template';
      this.notification = {
        label: 'Info',
        description: `${itemType} ${templateToLoad.name} is already loaded.`,
        type: 'info'
      };
      this.closeTemplateModal();
      return;
    }
    if (templateToLoad.query) {
      // First, set the GUID
      this.dataService.selectedGUID = this.currentFilterGuid = templateToLoad.guid;
      
      // Fetch version history to get the latest version BEFORE loading UI
      this.filterCriteriaService.getVersionHistory(templateToLoad.guid).subscribe({
        next: (versions) => {
          this.versionHistory = versions.map(v => ({
            versionNo: v.version,
            description: v.comments || '',
            filterCriteria: this.formatFilterCriteria(v.query),
            numberOfResults: '', 
            email: v.email,
            createdOn: v.createdOn,
            query: v.query,
            globalQuery: v.globalQuery,
            guid: v.guid,
            type: v.type,
            name: v.name
          }));
          this.filteredVersionHistory = [...this.versionHistory];

          // Get the latest version (by comparing version numbers)
          if (this.versionHistory.length > 0) {
            // Find the version with the highest version number
            const latestVersion = this.versionHistory.reduce((latest, current) => {
              const currentNum = this.parseVersionNumber(current.versionNo);
              const latestNum = this.parseVersionNumber(latest.versionNo);
              return currentNum > latestNum ? current : latest;
            }, this.versionHistory[0]);
            
            // Update GUID and version with latest version info
            this.dataService.selectedQuery = {
              comments: latestVersion.description || '',
              email: latestVersion.email || '',
              filter: latestVersion.query || '',
              filterType: latestVersion.type || '',
              name: templateToLoad.name || '',
              projectId: templateToLoad.projectId || '',
              versionNo: latestVersion.versionNo,
              globalFilter: latestVersion.globalQuery || ''
            };
            
            this.updatedVersion = latestVersion.versionNo;
            this.selectedVersions = [latestVersion];
            this.comments = latestVersion.description === '' ? '' : latestVersion.description;
            
            // Now load the query data with the latest version
            this.handlePopulatingGroups(latestVersion.query);
            this.updateSharedService();
            
            this.router.navigate(['../', this.currentFilterGuid], { relativeTo: this.activatedRoute });
            this.closeTemplateModal();

            this.notification = { description: '', label: '', type: '' };
            setTimeout(() => {
              const itemType = templateToLoad._isQuery ? 'Query' : 'Template';
              this.notification = {
                label: 'Success',
                description: `${itemType} "${templateToLoad.name}" loaded successfully`,
                type: 'success'
              };
            }, 10);

            setTimeout(() => {
              this.captureCurrentState();
            }, 200);

            this.cdr.detectChanges();
          }
        },
        error: (error) => {
          console.error('Error loading version history:', error);
          // Fallback: Load with the current template version if API fails
          this.updateGUIDAndVersion(templateToLoad);
          this.handlePopulatingGroups(templateToLoad.query);
          this.closeTemplateModal();

          this.notification = { description: '', label: '', type: '' };
          setTimeout(() => {
            const itemType = templateToLoad._isQuery ? 'Query' : 'Template';
            this.notification = {
              label: 'Success',
              description: `${itemType} "${templateToLoad.name}" loaded successfully`,
              type: 'success'
            };
          }, 10);

          setTimeout(() => {
            this.captureCurrentState();
          }, 200);

          this.cdr.detectChanges();
        }
      });
    }
  } catch (error) {
    console.error('Error loading template:', error);
    this.notification = { description: '', label: '', type: '' };
    setTimeout(() => {
      const itemType = templateToLoad._isQuery ? 'Query' : 'Template';
      this.notification = {
        label: 'Error',
        description: `Failed to load selected ${itemType.toLowerCase()}`,
        type: 'error'
      };
    }, 10);
  }
}

/**
 * Load a favourite query or template (from the side pane) into the editor.
 * Reuses the template-loading pipeline so unsaved-change prompts, group
 * population and GUID/version navigation all stay consistent.
 */
loadFilterFromFavorite(favorite: GetFilterQueryResponse, isTemplate: boolean = false): void {
  if (!favorite?.guid) {
    return;
  }

  const itemToLoad = {
    guid: favorite.guid,
    name: favorite.name,
    query: favorite.query,
    type: favorite.type,
    email: favorite.email,
    projectId: favorite.projectId,
    version: favorite.version,
    comments: favorite.comments,
    globalQuery: favorite.globalQuery,
    _isQuery: !isTemplate
  };

  if (this.hasChanges()) {
    this.pendingVersionToLoad = { ...itemToLoad, _isTemplate: isTemplate };
    this.showUnsavedChangesModal = true;
    return;
  }

  this.proceedWithLoadingTemplate(itemToLoad);
}

formatVersion(version: string): string {
  if (!version) return '';
  return version.replace(/^V/i, '');
}

updateGUIDAndVersion(selectedTemplate: any): void {
  this.dataService.selectedQuery = {
    comments: selectedTemplate.comments || '',
    email: selectedTemplate.email || '',
    filter: selectedTemplate.query || '',
    filterType: selectedTemplate.type || '',
    name: selectedTemplate.name || '',
    projectId: selectedTemplate.projectId || '',
    versionNo: selectedTemplate.version || this.initialVersion,
    globalFilter: selectedTemplate.globalQuery || ''
  };

  this.dataService.selectedGUID = this.currentFilterGuid = selectedTemplate.guid;
  this.updatedVersion = selectedTemplate.version || this.initialVersion;
  this.router.navigate(['../', this.dataService.selectedGUID], { relativeTo: this.activatedRoute });
}

openVersionHistoryModal(): void {
  this.showVersionHistoryModal = true;
  this.loadVersionHistory();
}

closeVersionHistoryModal(): void {
  this.showVersionHistoryModal = false;
  this.selectedVersions = [];
  this.editingVersionComment = null;
  this.versionCommentText = '';
  this.clearVersionSearchFilters();
}

onEditVersionComment(version: any, event: Event): void {
  event.stopPropagation();
  this.selectedVersions = [version];
  this.editingVersionComment = version;
  this.versionCommentText = version.description || '';
  this.onVersionCommentChange(this.versionCommentText);
}

onCancelEditVersionComment(): void {
  this.editingVersionComment = null;
  this.versionCommentText = '';
  this.versionCommentError = '';
}

onVersionCommentChange(value: string): void {
  if (value && value.length > 600) {
    this.versionCommentError = `Text exceeds 600 characters (current: ${value.length}). Please reduce the content before saving.`;
  } else {
    this.versionCommentError = '';
  }
}


onSaveVersionComment(): void {
  if (!this.editingVersionComment || this.isSavingVersionComment) {
    return;
  }

  const trimmedComment = this.versionCommentText.trim();

  if (trimmedComment.length > 600) {
    this.versionCommentError = `Text exceeds 600 characters (current: ${trimmedComment.length}). Please reduce the content before saving.`;
    return;
  }

  this.isSavingVersionComment = true;
  const versionNo = this.editingVersionComment.versionNo;

  this.filterCriteriaService.updateVersionComment(
    this.currentFilterGuid,
    versionNo,
    trimmedComment
  ).subscribe({
    next: () => {
      this.captureCurrentState();
      const versionInHistory = this.versionHistory.find(v => v.versionNo === versionNo);
      if (versionInHistory) {
        versionInHistory.description = trimmedComment;
      }
      const versionInFiltered = this.filteredVersionHistory.find(v => v.versionNo === versionNo);
      if (versionInFiltered) {
        versionInFiltered.description = trimmedComment;
      }
      this.editingVersionComment = null;
      this.versionCommentText = '';
      this.versionCommentError = '';
      this.isSavingVersionComment = false;
      this.notification = {
        label: 'Success',
        description: 'Comment updated successfully',
        type: 'success'
      };
    },
    error: (error: any) => {
      console.error('Error updating version comment:', error);
      this.isSavingVersionComment = false;
      this.notification = {
        label: 'Error',
        description: 'Failed to update comment',
        type: 'error'
      };
    }
  });
}


loadVersionHistory(): void {
  if (!this.currentFilterGuid) {
    return;
  }

  this.filterCriteriaService.getVersionHistory(this.currentFilterGuid).subscribe({
    next: (versions) => {
      this.versionHistory = versions.map(v => ({
        versionNo: v.version,
        description: v.comments || '',
        filterCriteria: this.formatFilterCriteria(v.query),
        numberOfResults: '', 
        email: v.email,
        createdOn: v.createdOn,
        query: v.query,
        globalQuery: v.globalQuery,
        guid: v.guid,
        type: v.type,
        name: v.name
      }));
      this.filteredVersionHistory = [...this.versionHistory];
      
      // Normalize version numbers for comparison (handle 'V001', '001', '1' formats)
      const normalizedCurrentVersion = this.normalizeVersion(this.updatedVersion);
      const currentVersion = this.versionHistory.find(v => 
        this.normalizeVersion(v.versionNo) === normalizedCurrentVersion
      );
      
      if (currentVersion) {
        this.selectedVersions = [currentVersion];
      } else if (this.versionHistory.length > 0) {
        // If no exact match found, select the latest version (first in list)
        this.selectedVersions = [this.versionHistory[0]];
      }
    },
    error: (error) => {
      console.error('Error loading version history:', error);
      this.notification = {
        label: 'Error',
        description: 'Failed to load version history',
        type: 'error'
      };
    }
  });
}

/**
 * Load version history and select the latest version (used when loading from favorites)
 */
private loadVersionHistoryForFavorite(): void {
  if (!this.currentFilterGuid) {
    return;
  }

  this.filterCriteriaService.getVersionHistory(this.currentFilterGuid).subscribe({
    next: (versions) => {
      this.versionHistory = versions.map(v => ({
        versionNo: v.version,
        description: v.comments || '',
        filterCriteria: this.formatFilterCriteria(v.query),
        numberOfResults: '', 
        email: v.email,
        createdOn: v.createdOn,
        query: v.query,
        globalQuery: v.globalQuery,
        guid: v.guid,
        type: v.type,
        name: v.name
      }));
      this.filteredVersionHistory = [...this.versionHistory];
      
      // Always select and load the latest version (find by highest version number)
      if (this.versionHistory.length > 0) {
        const latestVersion = this.versionHistory.reduce((latest, current) => {
          const currentNum = this.parseVersionNumber(current.versionNo);
          const latestNum = this.parseVersionNumber(latest.versionNo);
          return currentNum > latestNum ? current : latest;
        }, this.versionHistory[0]);
        this.selectedVersions = [latestVersion];
        
        // Load the query data for the latest version
        if (latestVersion.query) {
          this.handlePopulatingGroups(latestVersion.query);
          this.updatedVersion = latestVersion.versionNo;
          
          if (this.dataService.selectedQuery) {
            this.dataService.selectedQuery.versionNo = latestVersion.versionNo;
          }
          
          this.comments = latestVersion.description === '' ? '' : latestVersion.description;
          this.updateSharedService();
          this.cdr.detectChanges();
        }
      }
    },
    error: (error) => {
      console.error('Error loading version history for favorite:', error);
    }
  });
}

/**
 * Normalize version strings to handle different formats (V001, 001, 1, etc.)
 * Converts to a standard format for comparison
 */
private normalizeVersion(version: string): string {
  if (!version) return '';
  // Remove 'V' or 'v' prefix and leading zeros for comparison
  return version.replace(/^[Vv]/, '').toLowerCase().trim();
}

/**
 * Parse version number from string (e.g., "001" -> 1, "010" -> 10, "100" -> 100)
 * Used to find the latest version among multiple versions
 */
private parseVersionNumber(versionStr: string): number {
  if (!versionStr) return 0;
  // Remove 'V' or 'v' prefix and convert to number
  const numStr = versionStr.replace(/^[Vv]/, '').trim();
  const num = Number.parseInt(numStr, 10);
  return Number.isNaN(num) ? 0 : num;
}

onDeleteVersionClick(version: any, event: Event): void {
  event.stopPropagation();
  this.selectedVersions = [version];
  this.versionToDelete = version;
  this.showDeleteVersionModal = true;
}

cancelDeleteVersion(): void {
  this.versionToDelete = null;
  this.showDeleteVersionModal = false;
}

confirmDeleteVersion(): void {
  if (!this.versionToDelete || this.isDeletingVersion) {
    return;
  }

  this.isDeletingVersion = true;
  const versionNo = this.versionToDelete.versionNo;

  this.filterCriteriaService.deleteVersion(
    this.currentFilterGuid,
    versionNo
  ).subscribe({
    next: () => {
      this.captureCurrentState(); 
      this.versionHistory = this.versionHistory.filter(v => v.versionNo !== versionNo);
      this.filteredVersionHistory = this.filteredVersionHistory.filter(v => v.versionNo !== versionNo);
      this.selectedVersions = this.selectedVersions.filter(v => v.versionNo !== versionNo);
      this.versionToDelete = null;
      this.showDeleteVersionModal = false;
      this.isDeletingVersion = false;
      this.notification = { description: '', label: '', type: '' };
      setTimeout(() => {
        this.notification = {
          label: 'Success',
          description: `Version ${versionNo} deleted successfully`,
          type: 'success'
        };
      }, 10);
    },
    error: (error: any) => {
      console.error('Error deleting version:', error);
      this.isDeletingVersion = false;
      this.showDeleteVersionModal = false;
      this.versionToDelete = null;
      this.notification = { description: '', label: '', type: '' };
      setTimeout(() => {
        this.notification = {
          label: 'Error',
          description: error?.error?.message || 'Failed to delete version',
          type: 'error'
        };
      }, 10);
    }
  });
}

private formatFilterCriteria(queryString: string): string {
  if (!queryString) return '';
  
  try {
    const query = JSON.parse(queryString);
    
    if (query.conditions && Array.isArray(query.conditions)) {
      const criteriaItems = query.conditions
        .filter((cond: any) => cond.type === 'Filter')
        .map((cond: any) => `${cond.field} ${cond.operator} ${cond.value}`)
        .slice(0, 2); 
      
      const displayText = criteriaItems.join(', ');
      return criteriaItems.length < query.conditions.length 
        ? `${displayText}...` 
        : displayText;
    }
    
    return '';
  } catch (error) {
    console.error('Error formatting filter criteria:', error);
    return 'Invalid format';
  }
}

onVersionSearch(): void {
  this.filteredVersionHistory = this.versionHistory.filter(version => {
    const versionMatch = !this.versionSearchText || 
      version.versionNo?.toLowerCase().includes(this.versionSearchText.toLowerCase());
    
    const descriptionMatch = !this.descriptionSearchText || 
      version.description?.toLowerCase().includes(this.descriptionSearchText.toLowerCase());
    
    const criteriaMatch = !this.filterCriteriaSearchText || 
      version.filterCriteria?.toLowerCase().includes(this.filterCriteriaSearchText.toLowerCase());
    
    const resultsMatch = !this.resultsSearchText || 
      version.numberOfResults?.toString().includes(this.resultsSearchText);
    
    return versionMatch && descriptionMatch && criteriaMatch && resultsMatch;
  });
}


clearVersionSearchFilters(): void {
  this.versionSearchText = '';
  this.descriptionSearchText = '';
  this.filterCriteriaSearchText = '';
  this.resultsSearchText = '';
  this.filteredVersionHistory = [...this.versionHistory];
}

isVersionSelected(version: any): boolean {
  return this.selectedVersions.some(v => v.versionNo === version.versionNo);
}

onVersionRadioChange(version: any): void {
  this.selectedVersions = [version];
}

onVersionRowClick(version: any): void {
  this.selectedVersions = [version];
}

isAllVersionsSelected(): boolean {
  return this.filteredVersionHistory.length > 0 && 
         this.selectedVersions.length === this.filteredVersionHistory.length;
}

toggleAllVersions(): void {
  if (this.isAllVersionsSelected()) {
    this.selectedVersions = [];
  } else {
    this.selectedVersions = [...this.filteredVersionHistory];
  }
}

loadSelectedVersion(): void {
  if (this.selectedVersions.length === 0) {
    return;
  }

  const versionToLoad = this.selectedVersions[0];
  
  if (this.hasChanges()) {
    this.pendingVersionToLoad = versionToLoad;
    this.showUnsavedChangesModal = true;
    return;
  }

  this.proceedWithLoadingVersion(versionToLoad);
}

private proceedWithLoadingVersion(versionToLoad: any): void {
  try {
    if (versionToLoad.query) {
      this.handlePopulatingGroups(versionToLoad.query);
      
      this.updatedVersion = versionToLoad.versionNo;
      if (this.dataService.selectedQuery) {
        this.dataService.selectedQuery.versionNo = versionToLoad.versionNo;
      }
      this.updateSharedService();
      
      this.comments = versionToLoad.description === '' ? '' : versionToLoad.description;
      
      this.closeVersionHistoryModal();
      
      this.notification = { description: '', label: '', type: '' };
      setTimeout(() => {
        this.notification = {
          label: 'Success',
          description: `Version ${versionToLoad.versionNo} loaded successfully`,
          type: 'success'
        };
      }, 10);
      
      setTimeout(() => {
        this.triggerIVKForExistingConditions(false);
        this.captureCurrentState();
      }, 200);
      
      this.cdr.detectChanges();
    }
  } catch (error) {
    console.error('Error loading version:', error);
    this.notification = {
      label: 'Error',
      description: 'Failed to load selected version',
      type: 'error'
    };
  }
}

onDontSaveAndLoad(): void {
  this.showUnsavedChangesModal = false;
  if (this.pendingNavigation) {
    const url = this.pendingNavigation;
    this.pendingNavigation = null;
    this.sharedService.latestPayload = null;
    this.router.navigate([url]);
    return;
  }

  if (this.pendingVersionToLoad) {
    if (this.pendingVersionToLoad._isTemplate) {
      this.proceedWithLoadingTemplate(this.pendingVersionToLoad);
    } else {
      this.proceedWithLoadingVersion(this.pendingVersionToLoad);
    }
    this.pendingVersionToLoad = null;
  }
}


  onSaveChangesAndLoad(): void {

    if (!this.currentFilterGuid) {
      this.showUnsavedChangesModal = false;
      this.openSaveModel();
      return;
    }

    // Navigation case: save as a new version then navigate
    if (this.pendingNavigation) {
      const url = this.pendingNavigation;

      this.onSaveNewVersion(
        () => {
          this.showUnsavedChangesModal = false;
          setTimeout(() => {
            this.sharedService.latestPayload = null;
            this.router.navigate([url]);
          }, 1500);
        },
        () => {
          this.pendingNavigation = url;
          this.showUnsavedChangesModal = true;
        }
      );
      return;
    }

    // Version/template load case: save as NEW version then load selected version
    if (this.pendingVersionToLoad) {
      const versionToLoad = this.pendingVersionToLoad;
      this.showUnsavedChangesModal = false;
      this.isSaving = true;

      const filterPayload = this.preparePayload();
      const userEmail = this.dataService.profile.mail;

      const filterData: QueryFilter = {
        Name: this.dataService.selectedQuery?.name || '',
        Email: userEmail,
        Type: this.dataService.selectedQuery?.filterType || 'Standard',
        query: JSON.stringify(filterPayload.rootGroup),
        comments: this.comments,
        versionNo: this.updatedVersion,
        GlobalQuery: this.createGlobalQuery(),
        ProjectId: this.dataService.selectedQuery?.projectId || '',
        HasValue: this.dataService.selectedQuery?.filterType === QueryType.Template ? this.isSaveWithValues : false,
        isDefault: (this.savedFilterType === 'Template' || this.savedFilterType === 'Public_Template') ? this.isDefaultQuery : false,
      };

      this.filterCriteriaService.saveAsNewVersion(this.currentFilterGuid, filterData).subscribe({
        next: (response) => {
          // Update version number from response
          const newVersion = response?.message?.match(/V\d{3}/)?.[0] || '';
          if (newVersion) {
            this.updatedVersion = newVersion;
            if (this.dataService.selectedQuery) {
              this.dataService.selectedQuery.versionNo = newVersion;
            }
          }

          this.captureCurrentState();
          this.isSaving = false;

          // Show success notification
          this.notification = { description: '', label: '', type: '' };
          setTimeout(() => {
            this.notification = {
              label: 'Success',
              description: `Changes saved as new version ${this.formatVersion(newVersion) || ''}. Loading selected version...`,
              type: 'success',
            };
          }, 10);

          // Now load the pending version or template
          this.pendingVersionToLoad = null;
          if (versionToLoad._isTemplate) {
            this.proceedWithLoadingTemplate(versionToLoad);
          } else {
            this.proceedWithLoadingVersion(versionToLoad);
          }
        },
        error: (error) => {
          console.error('Error saving as new version:', error);
          this.isSaving = false;

          // Reopen modal on failure so user can retry
          this.showUnsavedChangesModal = true;

          let errorMessage = 'Failed to save changes. Please try again.';
          if (error?.error?.details?.includes('Maximum version limit')) {
            errorMessage = 'Maximum version limit (V999) reached. Cannot save as new version.';
          } else if (error?.error?.message) {
            errorMessage = error.error.message;
          }

          this.notification = { description: '', label: '', type: '' };
          setTimeout(() => {
            this.notification = {
              label: 'Error',
              description: errorMessage,
              type: 'error',
            };
          }, 10);
        }
      });
    }
  }


closeUnsavedChangesModal(): void {
  this.showUnsavedChangesModal = false;
  this.pendingVersionToLoad = null;
  this.pendingNavigation = null; 
}

private createGlobalQuery(): string {
  return '';
}

private checkGlobalQueryForCIStatus(globalQuery: string | undefined): boolean {
  if (!globalQuery || globalQuery.trim() === '') {
    return false;
  }

  try {
    const parsedQuery = JSON.parse(globalQuery);
    
    if (parsedQuery.type === 'Group' && parsedQuery.conditions && Array.isArray(parsedQuery.conditions)) {
      for (const condition of parsedQuery.conditions) {
        if (condition.type === 'Filter' && 
            (condition.field === 'STATUS' || condition.field === 'status' || condition.field === 'cistatus' || condition.field === 'CISTATUS' || condition.field === 'EQ Status') && 
            condition.operator === '=' && 
            (condition.value === 'active' || condition.value === 'Active')) {
          return true;
        }
      }
    }
    return false;
  } catch (error) {
    console.error('Error parsing GlobalQuery:', error);
    return false;
  }
}

onRunAndSave(): void {
    if (!this.currentFilterGuid) {
      this.notification = { description: '', label: '', type: '' };
      setTimeout(() => {
        // Scroll to the bottom of the page
        window.scrollTo({ 
          top: document.documentElement.scrollHeight, 
          behavior: 'smooth' 
        });
        this.notification = {
          label: 'Error',
          description: 'No filter loaded to create a new version.',
          type: 'error',
        };
      }, 10);
      return;
    }

    const filterPayload = this.preparePayload();
    const userEmail = this.dataService.profile.mail;

    const filterData: QueryFilter = {
      Name: this.dataService.selectedQuery?.name || '',
      Email: userEmail,
      Type: this.dataService.selectedQuery?.filterType || 'Standard',
      query: JSON.stringify(filterPayload.rootGroup),
      comments: this.comments,
      versionNo: this.updatedVersion,
      GlobalQuery: this.createGlobalQuery(),
      ProjectId: this.dataService.selectedQuery?.projectId || '',
      HasValue: this.dataService.selectedQuery?.filterType === QueryType.Template ? this.isSaveWithValues : false,
      isDefault: (this.savedFilterType === 'Template' || this.savedFilterType === 'Public_Template') ? this.isDefaultQuery : false,
    };

 this.isSaving = true;

    // For templates, update current version instead of creating a new version
    if (this.isTemplateFilter()) {
      this.filterCriteriaService.updateCurrentVersion(this.currentFilterGuid, filterData).pipe(
        catchError((error) => {
          this.notification = { description: '', label: '', type: '' };
          setTimeout(() => {
            this.notification = { label: 'Error', description: error?.error?.message || 'Failed to update template. Please try again.', type: 'error' };
          }, 10);
          return of(null);
        })
      ).subscribe((result) => {
        this.isSaving = false;
        if (result !== null) {
          this.captureCurrentState();
          this.notification = { description: '', label: '', type: '' };
          setTimeout(() => {
            this.notification = {
              label: 'Success',
              description: 'Template updated successfully.',
              type: 'success',
            };
          }, 10);
        }
      });
      return;
    }

    const save$ = this.filterCriteriaService.saveAsNewVersion(this.currentFilterGuid, filterData).pipe(
      catchError((error) => {
        let errorMessage = 'Failed to create new version. Please try again.';
        if (error?.error?.details?.includes('Maximum version limit')) {
          errorMessage = 'Maximum version limit (V999) reached. Cannot create more versions.';
        }
        this.notification = { description: '', label: '', type: '' };
        setTimeout(() => {
          this.notification = { label: 'Error', description: errorMessage, type: 'error' };
        }, 10);
        return of(null);
      })
    );

    const testRun$ = of(null).pipe(
      catchError(() => of(null))
    );

 forkJoin([save$, testRun$]).subscribe({
      next: ([saveResult]) => {
        this.isSaving = false;

        if (saveResult) {
          // reuse onSaveNewVersion success logic
          const newVersion = saveResult?.message?.match(/V\d{3}/)?.[0] || '';
          if (newVersion) {
            this.updatedVersion = newVersion;
            if (this.dataService.selectedQuery) {
              this.dataService.selectedQuery.versionNo = newVersion;
            }
          }
          this.captureCurrentState();
          this.notification = { description: '', label: '', type: '' };
          setTimeout(() => {
            this.notification = {
              label: 'Success',
              description: `New version ${newVersion || ''} created successfully.`,
              type: 'success',
            };
          }, 10);
        }
         this.testRun();
      }
    });
  }
  
  routeToHome() {
    if (this.hasChanges()) {
      this.pendingNavigation = '/';
      this.pendingVersionToLoad = null;
      this.showUnsavedChangesModal = true;
    } else {
      this.sharedService.latestPayload = null;
      this.router.navigate(['/']);
      this.sharedService.resetTestRun();
    }
  }

  private onBeforeUnload = (event: BeforeUnloadEvent): void => {
    if (this.hasChanges()) {
      event.preventDefault();
      event.returnValue = '';
    }
  };

  triggerIVKForExistingConditions(refreshSummary = true): void {
    // 1. Gather every material-no condition and the mat numbers it needs.
    const conditionMatNos: { condId: string; matNos: string[] }[] = [];
    const allMatNosSet = new Set<string>();

    for (const group of this.filterCriteriaDataService.groups) {
      for (const cond of group.conditions) {
        if (!this.filterCriteriaDataService.isMaterialNoField(cond.field)) continue;

        const raw = cond.value || '';
        const condId = cond.id.toString();

        const splitMatNos = (value: string): string[] =>
          value.split(/[(),&\s]+/).map((s: string) => s.trim()).filter(Boolean);

        // included values
        const included = typeof raw === 'string' ? splitMatNos(raw) : [];

        // excluded values
        const excludedRaw = this.filterCriteriaDataService.excludedValuesMap[cond.id] || '';
        const excluded = splitMatNos(excludedRaw);

        const matNos = [...new Set([...included, ...excluded])];

        if (matNos.length > 0) {
          conditionMatNos.push({ condId, matNos });
          matNos.forEach(m => allMatNosSet.add(m));
        }
      }
    }

    if (allMatNosSet.size === 0) {
      return;
    }

    const allMatNos = [...allMatNosSet];

    // 2. One API call for ALL material numbers across all rows.
    this.filterCriteriaService.getIVKDescription(allMatNos).pipe(
      catchError(() => of([] as { id: string; name: string }[])),
      takeUntil(this.destroy$)
    ).subscribe((results) => {
      // 3. Distribute the combined result back to each condition row.
      for (const { condId, matNos } of conditionMatNos) {
        const condResults = results.filter(r => matNos.includes(r.id));
        this.filterCriteriaDataService.ivkMap[condId] = condResults;

        // Keep per-condition cache in sync so later edits hit the cache.
        const cacheKey = matNos.join(',');
        this.ivkCache.set(cacheKey, condResults);
      }
      if (refreshSummary) {
        this.onRefreshSummary();
      }
      this.cdr.detectChanges();
    });
  }

  isFilterOwnedByOtherUser(): boolean {
    const currentUserEmail = this.dataService.profile?.mail;
    const filterOwnerEmail = this.dataService.selectedQuery?.email;
    return !!currentUserEmail && !!filterOwnerEmail && currentUserEmail.toLowerCase() !== filterOwnerEmail.toLowerCase();
  }

  @HostListener('window:popstate', ['$event'])
  onPopState(event: PopStateEvent) {
    this.sharedService.resetTestRun();
  }

  onTemplateTypeFilter(event: any): void {
    this.templateTypeSearchText = event.target.value;
    this.onTemplateSearch();
  }

  onVersionColumnReorder(event: any): void {
    const moved = this.versionColumns.splice(event.dragIndex, 1)[0];
    this.versionColumns.splice(event.dropIndex, 0, moved);
  }

  onTemplateColumnReorder(event: any): void {
    const moved = this.templateColumns.splice(event.dragIndex, 1)[0];
    this.templateColumns.splice(event.dropIndex, 0, moved);
  }

  private getTemplateSearchColumns(): string[] {
    const columns = (this.templateSearchColumnsValue || '')
      .split(',')
      .map(value => value.trim())
      .filter(value => !!value);

    if (columns.length > 0) {
      return columns;
    }

    return [...FilterCriteriaComponent.DEFAULT_TEMPLATE_SEARCH_COLUMNS];
  }

  private getTemplateColumnValue(template: any, columnKey: string): string {
    switch (columnKey) {
      case 'id':
        return String(template?.id ?? '').toLowerCase();
      case 'type':
        return String(template?.type ?? '').toLowerCase();
      case 'comments':
        return String(template?.comments ?? '').toLowerCase();
      case 'name':
      default:
        return String(template?.name ?? '').toLowerCase();
    }
  }

  private resolveTemplateColumnSelection(event: Event): string[] {
    const customEvent = event as CustomEvent<string | string[] | { value?: string | string[] }>;
    const detail = customEvent?.detail;

    if (Array.isArray(detail)) {
      return detail.map(value => String(value).trim()).filter(value => !!value);
    }

    if (typeof detail === 'string') {
      return detail.split(',').map(value => value.trim()).filter(value => !!value);
    }

    if (detail && typeof detail === 'object' && 'value' in detail) {
      const detailValue = detail.value;
      if (Array.isArray(detailValue)) {
        return detailValue.map(value => String(value).trim()).filter(value => !!value);
      }
      if (typeof detailValue === 'string') {
        return detailValue.split(',').map(value => value.trim()).filter(value => !!value);
      }
    }

    const inputTarget = event.target as HTMLInputElement | null;
    return (inputTarget?.value || '').split(',').map(value => value.trim()).filter(value => !!value);
  }

  private sortTemplatesForDisplay(templates: any[]): any[] {
    const favorites = templates.filter((t) => t?.isFavourite);
    const nonFavorites = templates.filter((t) => !t?.isFavourite);

    const sortedFavorites = [...favorites].sort((a, b) => {
      const aName = String(a?.name || '').toLowerCase();
      const bName = String(b?.name || '').toLowerCase();
      const nameCompare = aName.localeCompare(bName, undefined, {
        sensitivity: 'base',
      });

      if (nameCompare !== 0) {
        return nameCompare;
      }

      return String(a?.id || '').localeCompare(String(b?.id || ''));
    });

    const sortedNonFavorites = [...nonFavorites].sort((a, b) => {
      const aUid = Number(a?._uid ?? Number.MAX_SAFE_INTEGER);
      const bUid = Number(b?._uid ?? Number.MAX_SAFE_INTEGER);

      if (aUid !== bUid) {
        return aUid - bUid;
      }

      return String(a?.id || '').localeCompare(String(b?.id || ''));
    });

    return [...sortedFavorites, ...sortedNonFavorites];
  }

private sortQueriesByFavoriteAndName(queries: any[]): any[] {
  return sortQueriesByFavoriteAndNameUtil(queries);
}

onQuerySearch(resetOthersResults: boolean = true): void {
  if (resetOthersResults && this.isShowingQueryOthersResults) {
    this.isShowingQueryOthersResults = false;
    this.allQueries = [...this.myQueryList];
  }

  const idSearch = (this.templateIdSearchText || '').toLowerCase();
  const nameSearch = (this.templateNameSearchText || '').toLowerCase();
  const commentsSearch = (this.templateCommentsSearchText || '').toLowerCase();
  const globalSearch = (this.queryGlobalSearchText || '').trim().toLowerCase();

  this.filteredQueries = this.allQueries.filter((query) => {
    const idMatch = !idSearch || String(query?.id ?? '').toLowerCase().includes(idSearch);
    const nameMatch = !nameSearch || String(query?.name ?? '').toLowerCase().includes(nameSearch);
    const commentsMatch = !commentsSearch || String(query?.comments ?? '').toLowerCase().includes(commentsSearch);
    const globalMatch = !globalSearch || [
      String(query?.id ?? ''),
      String(query?.name ?? ''),
      String(query?.comments ?? '')
    ].some(v => v.toLowerCase().includes(globalSearch));
    return idMatch && nameMatch && commentsMatch && globalMatch;
  });
}

onQueryGlobalSearchInput(event: Event): void {
  const inputTarget = event.target as HTMLInputElement | null;
  this.queryGlobalSearchText = inputTarget?.value ?? '';
  this.onQuerySearch();
}

onQuerySearchOthers(): void {
  const searchTerm = (this.queryGlobalSearchText || '').trim();
  if (!searchTerm) {
    return;
  }

  this.isQueryOthersSearchLoading = true;
  this.isShowingQueryOthersResults = false;

  this.landingPageService.searchFilters(searchTerm, false).subscribe({
    next: (results) => {
      this.isQueryOthersSearchLoading = false;

      this.allQueries = this.sortQueriesByFavoriteAndName((results || []).map((query: any, index: number) => ({
        _uid: index,
        id: query?.id || '',
        name: query?.name || '',
        comments: query?.comments || '',
        query: query?.query || query?.filter || '',
        globalQuery: query?.globalQuery || query?.globalFilter || '',
        projectId: query?.projectId || '',
        version: query?.version || query?.versionNo || '',
        email: query?.email || '',
        guid: query?.guid || '',
        isFavourite: query?.isFavourite || false,
        createdOn: query?.createdOn || ''
      })));

      this.selectedTemplateItem = null;
      this.isShowingQueryOthersResults = true;
      this.filteredQueries = [...this.allQueries];
      this.onQuerySearch(false);
    },
    error: () => {
      this.isQueryOthersSearchLoading = false;
      this.isShowingQueryOthersResults = true;
      this.allQueries = [];
      this.filteredQueries = [];
      this.notification = {
        label: 'Error',
        description: 'Failed to search queries.',
        type: 'error'
      };
    }
  });
}

onQueryColumnReorder(event: any): void {
  const moved = this.queryColumns.splice(event.dragIndex, 1)[0];
  this.queryColumns.splice(event.dropIndex, 0, moved);
}

onQueryGlobalSearchClear(): void {
  this.queryGlobalSearchText = '';
  this.onQuerySearch();
}

toggleQueryColumnVisibilityPopup(): void {
  this.showQueryColumnVisibilityPopup = !this.showQueryColumnVisibilityPopup;
}

isQueryColumnVisible(columnKey: string): boolean {
  return this.queryTableColumns.find(col => col.key === columnKey)?.visible ?? true;
}

onQueryColumnVisibilityChange(columnToToggle: any, event: any): void {
  const columnIndex = this.queryTableColumns.findIndex(col => col.key === columnToToggle.key);
  if (columnIndex < 0) { return; }
  this.queryTableColumns[columnIndex].visible = event.target.active;
}

  onToggleFavorite(
    isFavourite: boolean,
    template: any,
  ): void {
    const updatedFilter = { ...template, isFavourite };
    this.filterCriteriaService
      .setFavorite(updatedFilter.guid, updatedFilter.isFavourite)
      .subscribe({
        next: () => {
          this.templateList = this.sortTemplatesForDisplay(
            this.templateList.map((query) =>
              query.guid === updatedFilter.guid ? updatedFilter : query,
            ),
          );
          this.myTemplateList = this.sortTemplatesForDisplay(
            this.myTemplateList.map((query) =>
              query.guid === updatedFilter.guid ? updatedFilter : query,
            ),
          );
          this.onTemplateSearch();

          const message = isFavourite
            ? 'Marked as favorite'
            : 'Removed from favorites';
          this.notification = {
            label: 'Success',
            description: message,
            type: 'success',
          };
          this.favoriteChanged.emit();
        },
      });
  }

  onToggleFavoriteinQuery(
    isFavourite: boolean,
    template: any,
  ): void {
    const updatedFilter = { ...template, isFavourite };
    this.filterCriteriaService
      .setFavorite(updatedFilter.guid, updatedFilter.isFavourite)
      .subscribe({
        next: () => {
          this.allQueries = this.sortQueriesByFavoriteAndName(
            this.allQueries.map((query) =>
              query.guid === updatedFilter.guid ? updatedFilter : query,
            ),
          );
          this.onQuerySearch();

          const message = isFavourite
            ? 'Marked as favorite'
            : 'Removed from favorites';
          this.notification = {
            label: 'Success',
            description: message,
            type: 'success',
          };
          this.favoriteChanged.emit();
        },
      });
  }

  isTemplateOwnedByCurrentUser(template: any): boolean {
    const currentUserEmail = this.dataService.profile?.mail;
    const templateOwnerEmail = template?.email;
    return !!currentUserEmail && !!templateOwnerEmail && currentUserEmail.toLowerCase() === templateOwnerEmail.toLowerCase();
  }

  setActiveTab(tab: 'template' | 'query'): void {
    this.activeTab = tab;
    if (tab === 'query') {
      this.onQuerySearch();
    }
  }

}